<template>
  <div
    v-if="!loadding"
    class="confirm-wrap"
  >
    <div class="text-c666 font-s16 mt-24 mb-16">
      {{ TLang("填写并核对收货信息", "orderConfirm") }}
    </div>
    <div class="border-ce5">
      <!-- address 订单收货地址模块 -->
      <orderAddress
        :defaultAddressId="addressId"
        :addressList="addressList"
        :loadding="!loadding"
        :editAddressItem="address"
        :newAddressNotice="newAddressNotice"
        :invalideDialog="invalideDialog"
        :epidemicDeliverInfo="epidemicDeliverInfo"
        :onSetDefaultAddress="onSetDefaultAddress"
        :onEdit="onEdit"
        :onAdd="onAdd"
        :sendGio="sendGio"
        :checkAddress="settleAccountInfo.isAllowed===1?[]:checkAddressList"
        :settleAccountInfo="settleAccountInfo"
      />
      <div class="line"></div>
      <orderHaitaoForm
        v-if="hasHaitao"
        ref="haitaoInfo"
      />
      <div
        v-if="hasHaitao"
        class="line"
      ></div>
      <!-- merchantList 中为可售商品 props buyGoodsList -->
      <div>
        <merchantList
          :buyGoodsList.sync="buyGoodsList"
          :epidemicDeliverInfo="epidemicDeliverInfo"
          :handlePartsNum="modifyPartsNum"
          :choosePartsLoading="choosePartsLoading"
          :fppConfigure="fppConfigure"
        />
      </div>
      
      <!-- notSaleProductsList 不可售商品列表 props notSaleProducts -->
      <notSaleProductsList :notSaleProducts="notSaleProducts" />
      <div
        v-if="couponInfo && couponInfo.coupon === 'Y'"
        class="youhuiquan-content"
      >
        <div class="left-title">
          {{ TLang("使用优惠券", "orderConfirm") }}
        </div>
        <div
          v-if="couponInfo && couponInfo.coupon === 'Y'"
          class="coupon-wrap"
        >
          <span>
            {{
              ReplaceText(
                "QQQ",
                couponInfo.availableCouponList.length || 0,
                ReplaceText(
                  "XXX",
                  couponInfo.couponNum,
                  TLang("couponCount", "orderConfirm")
                )
              )
            }} </span><span
            class="conponCode"
            @click="
              () => {
                showCouponDialog = true;
                sendGio(
                  TLang('优惠券信息', 'list'),
                  TLang('优惠券引导', 'list'),
                  {
                    content: TLang('点我扫码', 'list'),
                  }
                );
              }
            "
          >{{ TLang("couponCount2", "orderConfirm") }}</span>
        </div>
      </div>
      <!-- <div v-loading.fullscreen.lock="cardUseDisabled"> -->
      <div>
        <!-- 福利卡抵扣 -->
        <!-- payWay是否支持 1:卡支付 2:余额支付 3:积分支付 4:现金支付 true 支持 false 不支持  -->
        <div
          v-if="
            interestsInfo && interestsInfo.payWay && interestsInfo.payWay[1]
          "
          id="card"
        >
          <div class="line"></div>
          <div class="price-limit-part" v-if="fppConfigure.priceLimitAmount > 0">{{`本笔订单福豆最多可抵${(fppConfigure.priceLimitAmount || 0).toFixed(2)}${fppConfigure.groupItemShowRmbSymbol === 'Y'?'元':''}（1福豆抵扣1${fppConfigure.groupItemShowRmbSymbol === 'Y'?'元':''}）`}}</div>
          <freeCards
            :interestsInfo="interestsInfo"
            :allSelectCard="allSelectCard"
            :enableSelect="enableSelect"
            :sendGio="sendGio"
            :fppConfigure="fppConfigure"
            @updateShow="updateShow"
            @bindCard="binkNewCard"
          />
        </div>

        <!--使用账户余额抵扣 -->
        <div
          v-if="
            interestsInfo && interestsInfo.payWay && interestsInfo.payWay[2] && interestsInfo.balanceInfo
          "
          id="balance"
        >
          <div class="line"></div>
          <balanceList
            :interestsInfo="interestsInfo"
            :allSelectCard="allSelectCard"
            :enableSelect="enableSelect"
            :sendGio="sendGio"
            @func="getChooseData"
          />
        </div>
        <!--使用积分抵扣 -->
        <div
          v-if="
            interestsInfo && interestsInfo.payWay && interestsInfo.payWay[3]
          "
          id="integralInfo"
        >
          <div class="line"></div>
          <integralList
            :interestsInfo="interestsInfo"
            :allSelectCard="allSelectCard"
            :enableSelect="enableSelect"
            :sendGio="sendGio"
            @func="getChooseData"
          />
        </div>
      </div>
    </div>
    <div class="order-control">
      <div class="border-ce5 mt-16">
        <div class="settle-wrap">
          <div class="settle-wrap-item">
            <span class="font-c666">
              <em class="font-s14">{{ settleAccountInfo.orderTotalNums }}</em>
              {{ TLang("totalProduct2", "orderConfirm") }}，
              {{ TLang("商品总价", "list") }}
              {{ getCurrentUnionName(settleAccountInfo.union_name, true ) }}:
              <!-- ({{ fppConfigure.groupItemShowRmbSymbol === 'Y' ? '元' : settleAccountInfo.union_name }}): -->
            </span>
            <span class="text-num-c111">
              {{ settleAccountInfo.orderTotalGoodsAmount }}
            </span>
          </div>
          <div class="settle-wrap-item mt-12 order-freight">
            <el-tooltip
              v-if="settleAccountInfo.orderTotalFeight > 0"
              effect="light"
              placement="bottom"
            >
              <div slot="content">
                <ul class="feight-weight-info">
                  <!-- <li
                    v-for="(item, index) in buyGoodsList"
                    v-show="item.baseFreight > 0 || item.weightFreight > 0"
                    :key="`freight_${index}`"
                    :style="{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginBottom: '20px',
                    }"
                  >
                    <div :style="{ textAlign: 'left' }">
                      {{ item.merchantAlias }}&nbsp;&nbsp;
                    </div>
                    <ul>
                      <li
                        v-if="item.baseFreight > 0"
                        :style="{ marginBottom: '10px', textAlign: 'right' }"
                      >
                        {{ TLang("基础运费", "orderConfirm") }}({{ union_name }})：{{
                          (item.baseFreight * union_scale).toFixed(2)
                        }}
                      </li>
                      <li
                        v-if="item.weightFreight > 0"
                        :style="{ marginBottom: '10px', textAlign: 'right' }"
                      >
                        {{ TLang("续重运费", "orderConfirm") }}({{ union_name }})：{{
                          (item.weightFreight * union_scale).toFixed(2)
                        }}
                      </li>
                      <li
                        v-if="item.weightFreight > 0"
                        :style="{
                          background: 'rgba(153, 153, 153, .1)',
                          color: '#999999',
                          textAlign: 'right',
                          fontSize: '12px',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                          padding: '2px 6px',
                        }"
                      >
                        {{
                          "总重量" +
                            item.totalWeight +
                            "kg,超出重量" +
                            parseFloat(
                              (item.totalWeight - item.freeShipping).toFixed(3)
                            ) +
                            "kg,超出部分" +
                            item.noPostage * union_scale +
                            settleAccountInfo.union_name +
                            "/kg"
                        }}
                      </li>
                    </ul>
                  </li> -->
                  <li
                    v-for="(item, index) in freightInfoList"
                    v-show="item.baseFreight > 0 || item.weightFreight > 0"
                    :key="`freight_${index}`"
                    :style="{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginBottom: '20px',
                    }"
                  >
                    <div :style="{ textAlign: 'left' }">
                      {{ item.showName }}&nbsp;&nbsp;
                    </div>
                    <ul>
                      <li
                        v-if="item.baseFreight > 0"
                        :style="{ marginBottom: '10px', textAlign: 'right' }"
                      >
                        {{ TLang("基础运费", "orderConfirm") }}{{getCurrentUnionName(union_name, true)}}：{{ (item.baseFreight * union_scale).toFixed(2) }}
                      </li>
                      <li
                        v-if="item.weightFreight > 0"
                        :style="{ marginBottom: '10px', textAlign: 'right' }"
                      >
                        {{ TLang("续重运费", "orderConfirm") }}{{getCurrentUnionName(union_name,true)}}：{{ (item.weightFreight * union_scale).toFixed(2) }}
                      </li>
                      <li
                        v-if="item.weightFreight > 0"
                        :style="{
                          background: 'rgba(153, 153, 153, .1)',
                          color: '#999999',
                          textAlign: 'right',
                          fontSize: '12px',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                          padding: '2px 6px',
                        }"
                      >
                        {{
                          CookiesOne === "en-US"
                            ? TLang("总重量", "list") +
                              item.totalWeight +
                              TLang("超出重量", "list") +
                              parseFloat(
                                (item.totalWeight - item.freeShipping).toFixed(
                                  3
                                )
                              ) +
                              "/kg" +
                              item.noPostage * union_scale +
                              settleAccountInfo.union_name +
                              TLang("超出部分的", "list")
                            : TLang("总重量", "list") +
                              item.totalWeight +
                              TLang("超出重量", "list") +
                              parseFloat(
                                (item.totalWeight - item.freeShipping).toFixed(
                                  3
                                )
                              ) +
                              TLang("超出部分", "list") +
                              item.noPostage * union_scale +
                              settleAccountInfo.union_name +
                              "/kg"
                        }}
                      </li>
                    </ul>
                  </li>
                </ul>
                <div
                  class="showFreightRule"
                  @click="showFreightRule"
                >
                  {{ TLang("运费收取规则", "orderConfirm") }}
                </div>
              </div>
              <el-button
                :style="{ position: 'absolute', background: 'rgba(0,0,0,0)' }"
              ></el-button>
            </el-tooltip>
            <img
              v-if="settleAccountInfo.orderTotalFeight > 0"
              src="@assets/images/order/freightRule.png"
              width="16px"
            />
            <span
              class="font-c666" id="totalFreight"
            >{{ TLang("运费", "orderConfirm") }}{{ getCurrentUnionName(settleAccountInfo.union_name, true ) }}:</span>
            <span class="text-num-c111">
              {{ settleAccountInfo.orderTotalFeight }}
            </span>
            <div class="tips" v-if="showFreightTips">{{ TLang('收货地址修改，运费发生变化', 'orderConfirm') }}</div>
          </div>
          <div class="settle-wrap-item mt-12" v-if="settleAccountInfo.totalServiceFee > 0">
            <el-tooltip
              effect="light"
              placement="bottom-end"
              :content="tipContent"
            >
             <span class="line-service">
                <img src="@assets/images/order/freightRule.png"/>
                {{ TLang('平台服务费','my') }}:
              </span>
            </el-tooltip>
            <span class="text-num-c111">
              {{ Number(settleAccountInfo.totalServiceFee).toFixed(2) }}
            </span>
          </div>
          <div v-if="fppConfigure && fppConfigure.groupItem !== 'Y' || !fppConfigure">
            <div
            v-if="activeReduceNum > 0"
            class="settle-wrap-item mt-12"
          >
            <span
              class="font-c666"
            >{{ TLang("立减", "orderConfirm") }} ({{
              settleAccountInfo.union_name
            }}):</span>
            <!-- <span class="text-num-c111">
              -{{ settleAccountInfo.reducePrice }}
            </span> -->
            <!-- 优惠金额设置膨胀比 -->
            <span class="text-num-c111">
              -{{ (activeReduceNum * union_scale).toFixed(2) }}
            </span>
          </div>
          <!-- 折上折 专享优惠 -->
          <div
            v-if="settleAccountInfo.additionalDiscountAmount"
            class="settle-wrap-item mt-12"
          >
            <span
              class="font-c666"
            >{{ TLang("专享优惠", "orderConfirm") }}({{
              settleAccountInfo.union_name
            }}):</span>
            <span class="text-num-c111">
              -{{
                (
                  (settleAccountInfo.additionalDiscountAmount || 0) *
                  union_scale
                ).toFixed(2)
              }}
            </span>
          </div>
          </div>
          <div
            v-if="cardDeductionMoney"
            class="settle-wrap-item mt-12"
          >
            <span
              class="font-c666"
            >{{ TLang("福利卡抵扣", "orderConfirm") }}
            {{ getCurrentUnionName(interestsInfo.cardInfo.name || TLang("福豆", "orderConfirm" ), true) }}
            <!-- ({{
              fppConfigure.groupItemShowRmbSymbol === 'Y' ? '元' : interestsInfo.cardInfo.name || TLang("福豆", "orderConfirm")
              
            }}) -->
            :</span>
            <!-- 优惠金额设置膨胀比 -->
            <span class="text-num-c111"> -{{ cardDeductionMoney }} </span>
          </div>
          <div
            v-if="balanceDeductionMoney"
            class="settle-wrap-item mt-12"
          >
            <span
              class="font-c666"
            >{{ TLang("账户余额抵扣", "orderConfirm") }}({{
              interestsInfo.balanceInfo.pointAccountUnitName ||
                TLang("福豆", "orderConfirm")
            }}):</span>
            <span class="text-num-c111"> -{{ balanceDeductionMoney }} </span>
          </div>
          <div
            v-if="intergralDeductionMoney"
            class="settle-wrap-item mt-12"
          >
            <span
              class="font-c666"
            >{{ TLang("账户积分抵扣", "orderConfirm") }}({{
              interestsInfo.integralInfo.integralUnitName ||
                TLang("福豆", "orderConfirm")
            }}):</span>
            <!-- 优惠金额设置膨胀比 -->
            <span class="text-num-c111"> -{{ intergralDeductionMoney }} </span>
          </div>
          <div class="settle-wrap-item mt-12">
            <span class="font-c666">
              {{ TLang("还需支付", "orderConfirm") }}
            </span>
            <span>
              <img
                v-if="remainingPayAmount && fppConfigure.groupItem !== 'Y'"
                :src="settleAccountInfo.fudou"
                alt
                class="fudou-15"
              />
              <em class="text-num-bold-red font-s20">
                {{fppConfigure && fppConfigure.groupItemShowRmbSymbol === 'Y'?'&#65509;':''}}{{ fppConfigure && fppConfigure.groupItem === 'Y' ? getPriceDeal(interestsInfo.paymentAmount-interestsInfo.deductionAmount) : (remainingPayAmount ? remainingPayAmount : "0.00") }}
              </em>
            </span>
          </div>
          <div
            v-if="tipsPassword === 'Y'"
            class="settle-wrap-item mt-12 line-middle"
          >
            <img
              class="select-icon"
              :src="noSecretSet ? selected : noSelect"
              @click="noSecretSet = !noSecretSet"
            />
            <em class="tip-span">{{
              ReplaceText(
                "XXX",
                settleAccountInfo.union_name || TLang("福豆", "orderConfirm"),
                TLang("openPayChannel", "orderConfirm")
              )
            }}</em>
            <img
              class="tip-icon"
              :src="tipIcon"
              @click="mianmiVisible = true"
            />
          </div>
          <div class="settle-wrap-item mt-20 clearfix settle-display">
            <!-- <a
              v-if="showTip && tipTitle[0]"
              @click="() => {
                gotoUse();
                sendGio('新人引导', '新人引导', {
                  content: `${tipTitle[0]}移到这里啦，请选择使用！`
                });
              }"
            >
              <div class="settle-tip">
                <em>{{ tipTitle[0] }}</em>移到这里啦，请选择使用！
                <img
                  style="width: 12px"
                  :src="require('@assets/images/up.png')"
                />
              </div>
            </a> -->
            <div
              id="create-order"
              v-loading.fullscreen.lock="createOrderDisabled"
              class="btn-theme-w150 fr"
              :class="{
                'order-disable':
                  all_valided ||
                  settleAccountInfo.isAllowed===0 ||
                  (epidemicDeliverInfo.allowDelivery === 0 &&
                  epidemicDeliverInfo.mandatoryType === 0) ||
                  moneyPay === 'N',
              }"
              @click="
                () => {
                  sendGio('提交订单', '提交订单');
                  onCreateOrder();
                }
              "
            >
              {{ TLang("提交订单", "orderConfirm") }}
            </div>
          </div>
          <div class="mt-12 text-right">
            <span
              class="dib mr-8 font-c999"
            >{{ TLang("收货信息", "orderConfirm") }}：{{
              settleAccountInfo.consigneeInfo
            }}</span>
            <span class="font-c999">{{ settleAccountInfo.addressInfo }}</span>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      title=" "
      :visible="invalideDialog && !editAddressDialog"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="order-invalide-dialog"
      center
      top="50vh"
      :show-close="false"
      @open="invalideDialog = true"
      @close="invalideDialog = false"
    >
      <img :src="require('@assets/images/smallBell.png')" />
      <p class="desc part_valided">
        {{ confirmOrderTips }}
      </p>
      <div>
        <button
          class="btns close"
          @click="closeDialog"
        >
          {{ TLang("我知道了", "orderConfirm") }}
        </button>
        <a
          v-if="all_valided"
          class="btns back"
          :href="backLink"
          target="_self"
        >{{ all_valideButton }}</a>
      </div>
    </Dialog>
    <Dialog
      :title="this.TLang('信息确认', 'orderConfirm')"
      :visible="birthdayRemarkModal"
      width="528px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="birthday-nuoxin-dialog"
      center
      top="50vh"
      @open="birthdayRemarkModal = true"
      @close="birthdayRemarkModal = false"
    >
      <div class="content">
        <!-- <h3>信息确认</h3> -->
        <p>
          <span
            class="head-text"
          >{{ TLang("生日牌内容", "orderConfirm") }}：</span>
          <span class="userremark">{{
            userRemark || TLang("生日快乐", "list")
          }}</span>
        </p>
        <div class="nuoxin-footer">
          <div
            v-loading.fullscreen.lock="createOrderDisabled"
            class="nuoxin-confirm"
            @click="onCreateOrder"
          >
            {{ TLang("提交订单", "orderConfirm") }}
          </div>
          <div
            class="nuoxin-close"
            @click="birthdayRemarkModal = false"
          >
            {{ TLang("返回修改", "orderConfirm") }}
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 优惠券提示 -->
    <Dialog
      title=" "
      :visible="showCouponDialog"
      width="720px"
      custom-class="couponDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      top="50vh"
      :show-close="true"
      @open="showCouponDialog = true"
      @close="showCouponDialog = false"
    >
      <CouponTip :qrcodeImg="qrcodeImg" />
    </Dialog>
    <Popups
      v-if="!union_isBilingual"
      ref="popus"
      :showCancel="isShowCancel"
      :showPopus="editAddressDialog"
      :title="addressDialog.title"
      :addressItem="addressDialog.addressItem"
      :dialogState="addressDialog.dialogState"
      :sendGio="sendGio"
      @onConfirmEditAddressDialog="onConfirmEditAddressDialog"
      @onCancelEditAddressDialog="onCancelEditAddressDialog"
      :checkAddress="checkAddressList"
    />
    <PopupsEn
      v-if="union_isBilingual"
      ref="popus"
      :showCancel="isShowCancel"
      :showPopus="editAddressDialog"
      :title="addressDialog.enTitle"
      :addressItem="addressDialog.addressItem"
      :dialogState="addressDialog.dialogState"
      :sendGio="sendGio"
      @onConfirmEditAddressDialog="onConfirmEditAddressDialog"
      @onCancelEditAddressDialog="onCancelEditAddressDialog"
      :checkAddress="checkAddressList"
    />
    <!-- 微创健康提示 -->
    <Dialog
      title=" "
      :visible="visitRefundFlag"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="order-invalide-dialog"
      center
      top="50vh"
      :show-close="false"
      @open="visitRefundFlag = true"
      @close="visitRefundFlag = false"
    >
      <img :src="require('@assets/images/smallBell.png')" />
      <p class="desc part_valided mpTip">
        {{ TLang("微创年度健康福利提示", "orderConfirm") }}
      </p>
      <p class="mpDesc">
        {{ TLang("wcTips1", "orderConfirm") }}
      </p>
      <div>
        <button
          class="btns mpOk"
          @click="mpOk"
        >
          {{ TLang("确定", "orderConfirm") }}
        </button>
        <button
          class="btns mpClose"
          @click="mpClose"
        >
          {{ TLang("取消", "orderConfirm") }}
        </button>
      </div>
    </Dialog>
    <!-- 未选择福利卡/账户余额提示弹窗 -->
    <Dialog
      title=""
      custom-class="my-tip-modal"
      :visible="unChooseRightsModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="false"
      top="40vh"
      @close="unChooseRightsModalVisible = false"
    >
      <div class="content">
        <img
          src="../../../assets/images/confirm-bell.png"
          alt="icon"
        />
        <div class="state">
          <div>
            {{
              ReplaceText(
                "XXX",
                tipTitle[0],
                TLang("CardStatus", "orderConfirm")
              )
            }}
          </div>
          <div>{{ TLang("是否去使用", "orderConfirm") }}？</div>
        </div>
        <div class="btns">
          <div
            class="cacel-btn"
            @click="
              () => {
                sendGio(
                  TLang('未使用弹框', 'list'),
                  TLang('提交订单', 'list'),
                  {
                    content: `${TLang('您有可用', 'list')}${tipTitle[0]}${TLang(
                      '未使用',
                      'list'
                    )}`,
                  }
                );
                goNextCreateOrder(true);
              }
            "
          >
            {{ TLang("提交订单", "orderConfirm") }}
          </div>
          <div
            class="yes-btn"
            @click="
              () => {
                sendGio(
                  TLang('未使用弹框', 'list'),
                  TLang('去使用', 'orderConfirm'),
                  {
                    content: `${TLang('您有可用', 'list')}${tipTitle[0]}${TLang(
                      '未使用',
                      'list'
                    )}`,
                  }
                );
                gotoUse();
              }
            "
          >
            {{ TLang("去使用", "orderConfirm") }}
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 未设置支付密码提示弹窗 -->
    <Dialog
      title=""
      custom-class="my-tip-modal"
      :visible="noPayPwdModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      @close="noPayPwdModalVisible = false"
    >
      <div class="content">
        <img
          src="../../../assets/images/confirm-bell.png"
          alt="icon"
        />
        <div class="state">
          <div>{{ TLang("NoPwd1", "orderConfirm") }}，</div>
          <div>{{ TLang("NoPwd2", "orderConfirm") }}</div>
        </div>
        <div class="single-btn-wrap">
          <div
            class="yes-btn"
            @click="openSetPwdModal"
          >
            {{ TLang("立即设置", "orderConfirm") }}
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 退出设置支付密码二次确认提示弹窗 -->
    <Dialog
      title=""
      custom-class="my-tip-modal"
      :visible="quitModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="false"
      top="40vh"
      @close="quitModalVisible = false"
    >
      <div class="content">
        <img
          src="../../../assets/images/confirm-bell.png"
          alt="icon"
        />
        <div class="state">
          <div>{{ TLang("是否退出设置支付密码", "orderConfirm") }}？</div>
        </div>
        <div class="btns">
          <div
            class="cacel-btn"
            @click="quitPwdSet"
          >
            {{ TLang("退出", "orderConfirm") }}
          </div>
          <div
            class="yes-btn"
            @click="goOnSet"
          >
            {{ TLang("继续设置", "orderConfirm") }}
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 绑定手机/获取短信验证码弹窗 -->
    <Dialog
      :title="modalTitle"
      custom-class="my-custom-modal bind-mobile-modal"
      :visible="bindTelModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      :before-close="(done) => closeClick(done, 'bindPhone')"
    >
      <div class="content">
        <div class="input-wrap mb18">
          <div class="name">
            {{ TLang("手机号", "address") }}
          </div>
          <input
            v-if="!mobile"
            v-model="phone"
            class="box"
            type="number"
            :placeholder="this.TLang('请输入11位手机号', 'address')"
            autocomplete="new-password"
            @blur="
              () => {
                sendGio(
                  TLang('绑定手机号', 'list'),
                  TLang('输入手机号码输入框', 'list')
                );
              }
            "
          />
          <div
            v-else
            class="mobile"
          >
            {{ mobile | mobileFormat }}
          </div>
        </div>
        <div class="input-wrap">
          <div class="name">
            {{ TLang("验证码", "address") }}
          </div>
          <div class="box sms">
            <input
              ref="smsCode"
              v-model="smsCode"
              type="number"
              maxlength="6"
              class="sms-code"
              :placeholder="this.TLang('请输入验证码', 'address')"
              autocomplete="new-password"
              autofocus="autofocus"
            />
            <div
              v-if="time == 60"
              class="get-code"
              @click="getSms"
            >
              {{ TLang("获取验证码", "address") }}
            </div>
            <div
              v-else
              class="reget-code"
            >
              {{ TLang("重新发送", "address") }}({{ time }}S)
            </div>
          </div>
        </div>
        <div
          class="next"
          :class="{ active: smsCode != '' }"
          @click="valiSms"
        >
          {{ TLang("下一步", "address") }}
        </div>
      </div>
    </Dialog>
    <!-- 短信验证码弹窗 -->
    <Dialog
      :title="this.TLang('输入短信验证码', 'address')"
      custom-class="my-custom-modal input-sms-modal"
      :visible="smsModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      @close="smsModalVisibl = false"
    >
      <div>{{ TLang("待完善", "address") }}</div>
    </Dialog>
    <!-- 设置支付密码弹窗 -->
    <Dialog
      :title="TLang('设置4位支付密码', 'list')"
      :visible="setPwdModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      custom-class="my-custom-modal"
      :before-close="(done) => closeClick(done, 'setPwd')"
    >
      <div class="content">
        <div class="item mb24">
          <div class="name pl28">
            {{ TLang("新的支付密码", "address") }}
          </div>
          <input
            v-model="paymentPwd"
            type="password"
            maxlength="4"
            :placeholder="this.TLang('输入4位数字密码', 'address')"
            @blur="
              () => {
                sendGio(
                  TLang('支付密码', 'list'),
                  TLang('新的密码输入框', 'list')
                );
              }
            "
          />
        </div>
        <div class="item mb8">
          <div class="name">
            {{ TLang("确认新的支付密码", "address") }}
          </div>
          <input
            v-model="reInputPaymentPwd"
            maxlength="4"
            type="password"
            :placeholder="this.TLang('再次输入4位数字密码', 'address')"
            @blur="
              () => {
                sendGio(
                  TLang('支付密码', 'list'),
                  TLang('二次确认密码输入框', 'list')
                );
              }
            "
          />
        </div>
        <div
          v-if="setPayPwdTips"
          class="tips"
        >
          <!-- <img src="" alt="icon"> -->
          <span>{{ setPayPwdTips }}</span>
        </div>
        <div
          v-else
          class="empty-tips"
        ></div>
        <div
          class="confirm-btn active"
          @click="confirmSetPwd"
        >
          {{ TLang("确认设置", "address") }}
        </div>
      </div>
    </Dialog>
    <!-- 黄牛提示弹窗 -->
    <Dialog
      title=""
      custom-class="my-tip-modal"
      :visible="huangniuVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      @close="huangniuVisible = false"
    >
      <div class="content">
        <img
          src="../../../assets/images/confirm-bell.png"
          alt="icon"
        />
        <div class="state">
          <div class="tip">
            {{
              unionFlag
                ? ReplaceText(
                  "400-003-1010",
                  "400-618-2999",
                  TLang("service", "orderConfirm")
                )
                : TLang("service", "orderConfirm")
            }}
          </div>
        </div>
        <div class="single-btn-wrap">
          <div
            class="yes-btn"
            @click="
              () => {
                huangniuVisible = false;
                sendGio(
                  TLang('福利卡', 'orderConfirm'),
                  TLang('知道了', 'orderConfirm'),
                  { content: TLang('黄牛弹框', 'list') }
                );
              }
            "
          >
            {{ TLang("知道了", "orderConfirm") }}
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 开通免密提示 -->
    <Dialog
      title=""
      custom-class="my-tip-modal"
      :visible="mianmiVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      @close="mianmiVisible = false"
    >
      <div class="content">
        <div class="state">
          <div class="tip-title">
            {{ TLang("免密抵扣使用规则", "orderConfirm") }}
          </div>
          <div class="tip tip-new">
            {{
              ReplaceText(
                "XXX",
                ((this.noPasswordMoney / 100) * union_scale).toFixed(2),
                TLang("mianmiTips", "orderConfirm")
              )
            }}
          </div>
        </div>
        <div class="single-btn-wrap">
          <div
            class="yes-btn"
            @click="mianmiVisible = false"
          >
            {{ TLang("我知道了", "orderConfirm") }}
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 设置密码成功提示弹窗 -->
    <Dialog
      title=""
      custom-class="my-tip-modal"
      :visible="setPwdSuccessModal"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      @close="setPwdSuccessModal = false"
    >
      <div class="content">
        <img
          src="../../../assets/images/confirm-bell.png"
          alt="icon"
        />
        <div class="state">
          <div>{{ TLang("密码设置成功", "orderConfirm") }}</div>
          <div>{{ TLang("将为您生成订单并提交", "orderConfirm") }}！</div>
        </div>
        <div class="single-btn-wrap">
          <div
            class="yes-btn"
            @click="afterSetSuccess"
          >
            {{ TLang("知道了", "orderConfirm") }}
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 抵扣失败提示弹窗 -->
    <Dialog
      title=""
      custom-class="my-tip-modal"
      :visible="deductionFaliedModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      @close="deductionFaliedModalVisible = false"
    >
      <div class="content">
        <img
          src="../../../assets/images/confirm-bell.png"
          alt="icon"
        />
        <div class="state">
          <div>{{ TLang("本次抵扣失败！", "list") }}</div>
          <div>{{ TLang("请重新选择并提交订单", "orderConfirm") }}</div>
        </div>
        <div class="single-btn-wrap">
          <div
            class="yes-btn"
            @click="reloadPage"
          >
            {{ TLang("重新选择", "orderConfirm") }}
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 积分抵扣失败提示弹窗 -->
    <Dialog
      title=""
      custom-class="my-tip-modal"
      :visible="jifendeductionFaliedModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      @close="jifendeductionFaliedModalVisible = false"
    >
      <div class="content">
        <img
          src="../../../assets/images/confirm-bell.png"
          alt="icon"
        />
        <div class="state">
          <div>{{ TLang("本次抵扣失败", "orderConfirm") }}！</div>
          <div>{{ TLang("积分盘点中请稍后再试", "list") }}</div>
        </div>
        <div class="single-btn-wrap">
          <div
            class="yes-btn"
            @click="reloadPage"
          >
            {{ TLang("重新选择", "orderConfirm") }}
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 支付弹窗 -->
    <Dialog
      :title="this.TLang('输入支付密码', 'orderConfirm')"
      custom-class="my-custom-modal input-pwd-modal"
      :visible="inputPwdModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      @close="inputPwdModalVisible = false"
    >
      <div class="content">
        <div class="pwd-wrap">
          <input
            ref="node1"
            v-model="pw1"
            type="password"
            maxlength="1"
            @keyup="focusNext(pw1, 'node2', '')"
          />
          <input
            ref="node2"
            v-model="pw2"
            type="password"
            maxlength="1"
            @keyup="focusNext(pw2, 'node3', 'node1')"
          />
          <input
            ref="node3"
            v-model="pw3"
            type="password"
            maxlength="1"
            @keyup="focusNext(pw3, 'node4', 'node2')"
          />
          <input
            ref="node4"
            v-model="pw4"
            type="password"
            maxlength="1"
            @keyup="focusNext(pw4, '', 'node3')"
          />
        </div>
        <div class="second-row">
          <div
            v-if="inputPwdError"
            class="error-info"
          >
            {{ inputPwdError }}
          </div>
          <div
            v-if="dongjieShow"
            class="error-info"
          >
            {{
              `${this.TLang(
                "密码已被冻结",
                "orderConfirm"
              )}，${countDownTimer}${this.TLang("后再试", "orderConfirm")}`
            }}
          </div>
          <div
            v-else
            class="error-info"
          ></div>
          <div
            class="forgrt-pwsd"
            @click="forgrtPwd"
          >
            {{ TLang("忘记密码", "orderConfirm") }}
          </div>
        </div>
        <div class="btn-wrap">
          <div
            :class="{
              'confirm-pay-btn': true,
              active: !!pw1 & !!pw2 & !!pw3 & !!pw4,
            }"
            @click="validatePayPwd"
          >
            {{ TLang("确定", "orderConfirm") }}
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog
      :title="this.TLang('绑定福利卡', 'card')"
      custom-class="my-custom-modal bind-card-modal"
      :visible="bindCardModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      @close="
        bindCardModalVisible = false;
        cardPwdError = '';
      "
    >
      <div class="content">
        <div class="cardPwdDesc">
          {{ TLang("cardPWD1", "card") }}
        </div>
        <input
          ref="myInput"
          v-model="cardPwd"
          type="text"
          class="cardPwdInput"
          :placeholder="this.TLang('cardPWD2', 'card')"
          autofocus
          @blur="
            () => {
              sendGio(TLang('绑定福利卡', 'card'), TLang('卡密输入框', 'list'));
            }
          "
        />
        <div class="error-info">
          <img
            v-if="cardPwdError"
            src="../../../assets/images/icon_deliver_tip.png"
            alt=""
          />
          {{ cardPwdError }}
        </div>
        <div class="btn-wrap">
          <div
            :class="{ btn: true, active: !!cardPwd }"
            @click="bindCardValidate"
          >
            {{ TLang("确定", "orderConfirm") }}
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 绑定富利卡确认弹唱 -->
    <Dialog
      title=""
      custom-class="card-info-modal my-tip-modal"
      :visible="cardInfoModalVisible"
      width="450px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="15vh"
      center
      :show-close="false"
      @close="cardInfoModalVisible = false"
    >
      <div class="content">
        <img
          :src="require('@/assets/images/confirm-bell.png')"
          alt="icon"
        />
        <div class="state">
          <div class="confirmTitle">
            {{ TLang("确认绑定这张福利卡吗", "card") }}？
          </div>
          <div class="confirmCardInfo">
            <div class="cardName">
              {{
                unionF
                  ? cardConfirmModelInfo.kindForeignName
                  : cardConfirmModelInfo.kindName
              }}
            </div>
            <div class="cardTxt">
              {{ TLang("可用余额", "card") }}
              ({{
                cardConfirmModelInfo.type === 2
                  ? TLang("次", "orderConfirm")
                  : settleAccountInfo.union_name ||
                    TLang("福豆", "orderConfirm")
              }})
            </div>
            <div class="cardBalance">
              {{ formatBalance(cardConfirmModelInfo.balance)[0]
              }}<em>.{{ formatBalance(cardConfirmModelInfo.balance)[1] }}</em>
            </div>
            <div class="cardNo">
              {{ TLang("卡号", "card") }}:{{ cardConfirmModelInfo.cardNo }}
            </div>
            <div class="cardDate">
              {{ TLang("有效期至", "card") }}:{{
                formatTime(cardConfirmModelInfo.expireDate)
              }}
            </div>
          </div>
          <div v-if="cardConfirmModelInfo.oneCodeRedemptionStatus == 1" class="destory-card-content">
            <div class='destory-card-tipsLabel'>是否保留实体卡使用权限？</div>
            <div :class="{
              'destory-card-items': true,
              'destory-card-items-active': isKeepCard == 1}"  
              @click="() => {isKeepCard = isKeepCard == 1 ? null : 1}"
            >
                <img class='destory-card-logo' :src="isKeepCard == 1 ? saveSelectedIcon : saveUnselectIcon"/>
                <div class='destory-card-right'>
                  <div class='card-right-lable'>是，实体卡二维码仍可继续用于兑换</div>
                  <div class='card-right-waring'>(请保管好实体卡，丢失有被盗用风险)</div>
                </div>
                <div v-if="isKeepCard == 1" class='card-ckeck-content'></div>
                <img v-if="isKeepCard == 1" class='card-ckeck-img' :src="checkIcon"/>
            </div>
            <div :class="{
                'destory-card-items': true,
                'destory-card-items-active': isKeepCard == 2}"    
                @click="() => {isKeepCard = isKeepCard == 2 ? null : 2}"
            >
                <img class='destory-card-logo' :src="isKeepCard == 2 ? unsaveSelectedIcon : unsaveUnselectIcon"/>
                <div class='destory-card-right'>
                    <div class='card-right-lable'>否，实体卡将作废，您仅可用线上绑定的福利卡兑换</div>
                </div>
                <div v-if="isKeepCard == 2" class='card-ckeck-content'></div>
                <img v-if="isKeepCard == 2" class='card-ckeck-img' :src="checkIcon"/>
            </div>
          </div>
          <div class="confirmTips">
            <div class="confirmTipsTxt">
              {{ TLang("温馨提示", "address") }}：
            </div>
            <div class="confirmTipsTxt">
              {{ cardConfirmModelInfo.kindDesc }}
            </div>
            <!-- <div class="confirmTipsTxt">
              1.本卡仅限于线上演出频道（不可延期）
            </div> -->
          </div>
        </div>
        <div class="btn-wrap">
          <div
            class="btn active"
            @click="confirmBindCard"
          >
            {{ TLang("确认绑定", "card") }}
          </div>
          <div
            class="btn"
            @click="
              () => {
                sendGio(TLang('绑定福利卡', 'card'), TLang('取消', 'my'), {
                  contentTitle: cardConfirmModelInfo.kindName,
                });
                cardInfoModalVisible = false;
              }
            "
          >
            {{ TLang("取消", "orderConfirm") }}
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog
      :title="this.TLang('运费收取规则', 'orderConfirm')"
      :visible.sync="showFreightRuleFlag"
      width="420"
      center
      top="40vh"
      :before-close="handleClose"
      custom-class="freightDialog"
    >
    <span>
      {{
        ReplaceText(
          "QQQ",
          5 * union_scale + "" + union_name,
          ReplaceText(
            "&&&",
            99 * union_scale + "" + union_name,
            ReplaceText(
              "XXX",
              99 * union_scale + "" + union_name,
              TLang("FreightTips", "orderConfirm")
            )
          )
        )
      }}</span>
    </Dialog>
    <Dialog
      :title="''"
      :visible.sync="showPartsTipFlag"
      width="420"
      center
      top="40vh"
      custom-class="partsDialog"
      :before-close="createOrderAction"
    >
      <span>
        配件不支持独立售后、不支持换货/补发，请在申请蛋糕售后退款/退货退款时选择和蛋糕一起进行
      </span>
      <div
        class="partsKnowBtn"
        @click="showPartsTipFlag = false"
      >
        知道了
      </div>
    </Dialog>
    <Dialog
      :title="''"
      :visible="!invalideDialog && showPartsNoStockFlag"
      width="420"
      center
      top="40vh"
      custom-class="partsDialog"
    >
      <span> 抱歉，您的订单中部分配件已失效或库存不足，请重新选择 </span>
      <div
        class="partsKnowBtn"
        @click="showPartsNoStockFlag = false"
      >
        知道了
      </div>
    </Dialog>
    <Dialog
      :title="''"
      :visible="submitStockNullFlag"
      width="420"
      center
      top="40vh"
      custom-class="partsDialog"
    >
      <span>
        抱歉，您的订单中部分商品/配件已失效或库存不足，已为您删除，请重新确认后下单
      </span>
      <div
        class="partsKnowBtn"
        @click="submitReload"
      >
        知道了
      </div>
    </Dialog>
  </div>
</template>

<script>
import API_ENV from '@utils/API_ENV';
import { mapState, mapGetters, mapActions } from 'vuex';
import { payTotastNames } from '@utils/config';
import {
  getUserInfoHandle,
  getSmsHandle,
  valiSmsHandle,
  updateMobileHandle,
  setPaymentPwdHandle,
  validatePaymentPwdHandle,
  bindCardValidateHandle,
  bindCardHandle,
  choosePaymentWay,
} from '@fetch/order';
import { sha } from '@/utils/SHA';
import {
  formatDateTime,
  getMessageToCode,
  getUserCenterParams,
} from '@/utils/index';
import ConfirmDialog from '@components/confirmDialog';
import Cookies from 'js-cookie';
import { getQueryString, unionFlag, gioClickHandle } from '@utils/index';
import merchantList from './components/merchantList';
import notSaleProductsList from './components/notSaleProductList';
import orderSettle from './components/orderSettle';
import orderAddress from './components/orderAddress';
import orderHaitaoForm from './components/orderHaitaoForm';
import CouponTip from './components/couponTip';
import Loading from '@components/SimpleLoading';
import { confirmOrder, newCreateOrder, getQrcodeUrl } from '@fetch/order';
import { Dialog } from 'element-ui';
import Popups from './components/orderAddress/popups';
import PopupsEn from './components/orderAddress/popupsEn';
import Toast from '@components/simpleToast';
import balanceList from './components/balanceList';
// import balanceList from './components/balanceListNew';
import integralList from './components/integralList';

import freeCards from './components/freecards';
import {
  getUserAddressList,
  fetchUserAddressUpdate,
  checkAddress,
} from '@fetch/address';
let appid = '100037';
// let secretKey = '4d2dss';
const secretKey = 'TQaXTvES';
let _interval;
// const token = this.publicMethod.getCookie("dfflone");
export default {
  name: 'OrderConfirmV2',
  components: {
    orderAddress, //地址模块
    merchantList, //可售商品模块
    notSaleProductsList, //失效商品模块
    orderSettle, // 订单支付模块
    ConfirmDialog,
    orderHaitaoForm,
    Dialog,
    Popups,
    PopupsEn,
    CouponTip,
    balanceList,
    integralList,
    freeCards,
  },
  data() {
    return {
      isShowCancel: true,
      isFirstLoad: true, // 是否第一次加载
      isCallBackReload: false, // 地址添加窗口关闭后是否要触发重新加载地址
      isFirst: true, // 黄牛展示
      huangniuVisible: false, // 黄牛弹出框显示
      addressId: 0, // 默认收货地址 id
      address: null, // 收货地址
      goodsList: [], // 下单商品信息
      dongjieShow: false, // 冻结
      quitModalVisible: false, // 退出密码设置二次弹框
      loadding: true,
      confirmDialog: false,
      confirmOrderTips: this.TLang('orderGoodsInvalid', 'orderConfirm'),
      newAddressNotice: false,
      invalideDialog: false,
      visitRefundFlag: false,
      all_valided: false,
      part_valided: false,
      backLink: '',
      editdialog: false,
      addressDialog: {
        dialogState: true, // 编辑 false 添加 true
        title: this.TLang('新增收货地址', 'orderConfirm'),
        enTitle: this.TLang('新增收货地址', 'orderConfirm'),
        addressItem: null,
      }, // 地址新建、编辑弹层
      editAddressDialog: false,
      isReload: false, // 关闭弹窗是否需要刷新页面
      birthdayRemarkModal: false, // 诺心生日牌确认弹框
      userRemark: '', // 生日牌内容
      editAddressItem: {},
      addressList: [],
      createOrderDisabled: false,
      showCouponDialog: false, // PC暂时不展示优惠券，只提示
      unionFlag: unionFlag() || sessionStorage.getItem('dffl_union'),
      qrcodeImg: require('@assets/images/MiniApps.png'),
      noSelect: require('@assets/images/order/no_select.png'),
      selected: require('@assets/images/order/selected.png'),
      tipIcon: require('@assets/images/order/tip_icon.png'),
      checkIcon: require('./imgs/check.png'),
      saveSelectedIcon: require('./imgs/save-selected.png'),
      saveUnselectIcon: require('./imgs/save-unselected.png'),
      unsaveSelectedIcon: require('./imgs/unsave-selected.png'),
      unsaveUnselectIcon: require('./imgs/unsave-unselected.png'),
      unChooseRightsModalVisible: false, //未选择福利卡/账户积分余额提示弹窗
      bindTelModalVisible: false, //绑定手机号
      smsModalVisible: false, //短信验证码弹窗
      setPwdModalVisible: false, //设置支付密码弹窗
      setPwdSuccessModal: false,
      setPayPwdTips: '', //设置支付密码的错误提示信息
      inputPwdModalVisible: false, //支付弹窗
      inputPwdError: '', //密码错误信息
      pw1: '', //支付密码第1位
      pw2: '', //支付密码第2位
      pw3: '', //支付密码第3位
      pw4: '', //支付密码第4位
      paymentPwd: '', //第一次录入的支付密码
      reInputPaymentPwd: '', //再次输入的支付密码
      deductionFaliedModalVisible: false, //抵扣失败提示弹窗
      jifendeductionFaliedModalVisible: false, // 积分抵扣提醒失败
      noPayPwdModalVisible: false, //未设置支付密码提示弹窗
      mobile: '', //用户手机号
      hasPayPasswordSet: false, //用户是否已设置支付密码
      modalTitle: this.TLang('绑定您的手机号', 'orderConfirm'),
      time: 60, //倒计时秒数
      smsCode: '', //短信验证码
      bindCardModalVisible: false, //绑卡弹窗
      cardPwd: '', //卡密
      cardPwdError: '', //绑卡错误信息
      cardInfoModalVisible: false, //绑卡确认弹窗
      cardConfirmModelInfo: {}, //绑卡确认弹窗信息
      allSelectCard: {
        balanceCards: [], // 用户余额
        enterprisePoints: [], // 账户积分
        goodsCards: [], // 次卡
        pointCards: [], // 点卡
        timestamp: '', // 确认订单时间戳
        chooseType: 0, // 选择的卡类型 1：点卡 2.次卡 3.余额 4.积分
      },
      allCardInfo: {}, // 备份
      enableSelect: true, // 福利卡、账户、积分是否还可以再点击
      cardUseDisabled: false, // loading
      phone: '',
      showTip: false,
      countDownTimer: '',
      clearTimer: null,
      currentStep: '',
      getCodeNum: 0,
      isSetPassword: false,
      noSecretSet: false, // 免密抵扣设置 false 未勾选 true 已勾选
      tipsPassword: '', // 是否显示 开启免密支付
      originMianmiState: '',
      noPasswordMoney: 0,
      mianmiVisible: false,
      totalReduce: 0, // 总抵扣金额
      showFreightRuleFlag: false,
      unionF: unionFlag() || sessionStorage.getItem('dffl_union'),
      CookiesOne: Cookies.get('df_lang'),
      annexBuyGoodsList: [], // 收费配件
      showPartsTipFlag: false, // 配件不单独售后提示弹窗
      showPartsNoStockFlag: false, // 配件失效提示弹窗
      submitStockNullFlag: false, // 提交订单后商品库存不足提示框
      choosePartsLoading: false, // 配件选择调取接口，加载中
      checkAddressList: [], // 工会地址限制
      showFreightTips: false, // 运费变化提示
      isKeepCard: null, // 是否保留实体卡 1是  2否
    };
  },
  computed: {
    ...mapState('orderConfirm', [
      'hasHaitao',
      'createCode',
      'createOrderParameter',
      'confirmInfo'
    ]),
    ...mapState({
      buyGoodsList: (state) => state.orderConfirm.buyGoodsList,
      freightInfoList: (state) => state.orderConfirm.freightInfoList,
      annexItemStock: (state) => state.orderConfirm.annexItemStock,
      notSaleProducts: (state) => state.orderConfirm.notSaleGoodsList,
      settleAccountInfo: (state) => state.settleAccountInfo,
      energizerFreightInfo: (state) => state.energizerFreightInfo,
      interestsInfo: (state) => state.interestsInfo,
    }),
    ...mapGetters('orderConfirm', {
      buyGoodsList: 'getBuyGoodsList', // 可购买的商品
      freightInfoList: 'getFreightInfoList', // 运费
      annexItemStock: 'getAnnexItemStock', // 配件库存变化
      settleAccountInfo: 'getSettleAccountInfo', // 订单结算总计
      energizerFreightInfo: "getEnergizerFreightInfo", // 电子围栏运费变化
      userAddressList: 'getUserAddressList',
      notSaleGoodsList: 'getNotSaleGoodsList',
      epidemicDeliverInfo: 'getEpidemicDeliverInfo',
      couponInfo: 'getCouponInfo',
      confirmOrderTimestamp: 'getConfirmOrderTimestamp',
      oldTimestamp: 'getOldTimestamp',
      interestsInfo: 'getInterestInfo',
      fppConfigure: 'getFppConfigure',
    }),
    // 账户余额抵扣
    balanceDeductionMoney() {
      if (
        this.interestsInfo &&
        this.interestsInfo.balanceInfo &&
        this.interestsInfo.balanceInfo.deductionMoney
      ) {
        return Number(
          (this.interestsInfo.balanceInfo.deductionMoney * window.union_scale) /
            100,
        ).toFixed(2);
      }
      return 0;
    },
    // 账户积分抵扣
    intergralDeductionMoney() {
      if (
        this.interestsInfo &&
        this.interestsInfo.integralInfo &&
        this.interestsInfo.integralInfo.deductionMoney
      ) {
        return Number(
          (this.interestsInfo.integralInfo.deductionMoney *
            window.union_scale) /
            100,
        ).toFixed(2);
      }
      return 0;
    },
    // 福利卡抵扣
    cardDeductionMoney() {
      // 点卡加次卡
      var total = 0;
      if (
        this.interestsInfo &&
        this.interestsInfo.cardInfo &&
        this.interestsInfo.cardInfo.usableCardInfo
      ) {
        if (
          this.interestsInfo.cardInfo.usableCardInfo.totalPointMoney ||
          this.interestsInfo.cardInfo.usableCardInfo.totalTimeCardMoney
        ) {
          // 点卡抵扣总金额
          if (this.interestsInfo.cardInfo.usableCardInfo.totalPointMoney) {
            total += this.interestsInfo.cardInfo.usableCardInfo.totalPointMoney;
          }

          // 次卡抵扣总金额
          if (this.interestsInfo.cardInfo.usableCardInfo.totalTimeCardMoney) {
            total +=
              this.interestsInfo.cardInfo.usableCardInfo.totalTimeCardMoney;
          }
          total = Number((total * window.union_scale) / 100).toFixed(2);
        }
      }
      return total;
    },
    // 应付金额
    remainingPayAmount() {
      if (this.interestsInfo && this.interestsInfo.remainingPayAmount) {
        return Number(
          (this.interestsInfo.remainingPayAmount * window.union_scale) / 100,
        ).toFixed(2);
      }
      return 0;
    },

    // 商品金额
    paymentAmount() {
      if (this.interestsInfo && this.interestsInfo.paymentAmount) {
        return Number(
          (this.interestsInfo.paymentAmount * window.union_scale) / 100,
        ).toFixed(2);
      }
      return 0;
    },

    // 是否免密
    password() {
      if (this.interestsInfo && this.interestsInfo.password) {
        return this.interestsInfo.password;
      }
      return '';
    },

    // 提交订单按钮
    moneyPay() {
      // 是否支持第三方支付 Y支持
      if (this.interestsInfo && this.interestsInfo.moneyPay === 'N') {
        if (!this.interestsInfo.remainingPayAmount) {
          return 'Y';
        }
        return 'N';
      }
      return 'Y';
    },

    // 福利卡、余额、积分提示及跳转位置
    tipTitle() {
      var tip = '';
      var typeId = '';
      // 支持福利卡
      if (this.interestsInfo && this.interestsInfo.cardInfo) {
        tip = this.TLang('福利卡', 'orderConfirm');
        typeId = 'card';
      }
      // 支持账户余额
      if (this.interestsInfo && this.interestsInfo.balanceInfo) {
        if (tip) {
          tip += '/' + this.TLang('余额', 'orderConfirm');
        } else {
          tip = this.TLang('余额', 'orderConfirm');
          typeId = 'balance';
        }
      }
      // 支持账户积分
      if (this.interestsInfo && this.interestsInfo.integralInfo) {
        if (tip) {
          tip += '/' + this.TLang('积分', 'orderConfirm');
        } else {
          tip = this.TLang('积分', 'orderConfirm');
          typeId = 'integralInfo';
        }
      }
      if (tip) {
        typeId = '#' + typeId;
      }
      return [tip, typeId];
    },
    // 立减金额
    activeReduceNum() {
      const num =
        (this.settleAccountInfo.reducePrice || 0) -
        (this.settleAccountInfo.additionalDiscountAmount || 0);
      if (num > 0) {
        return num;
      }
      return 0;
    },
    tipContent() {
      return <div style={{width:'200px', display:'flex', color:'#333'}}>
        {TLang('服务费不计入包邮或满减门槛，以上门槛基于商品实际金额计算','my')}
      </div>
    },
  },
  watch: {
    buyGoodsList(oval, nval) {
      if (!nval) return null;
      if (oval == nval) return;
      this.loadding = false;
      Loading.hide();
      this.choosePartsLoading = false;
    },
    notSaleGoodsList: {
      handler(oldVal, newVal) {
        this.checkIsShowGoodsTip();
      },
      deep: true,
    },
    couponInfo: {
      handler(oldVal, newVal) {
        this.getQrCode();
      },
      deep: true,
    },
    annexItemStock: {
      handler(oldVal, newVal) {
        this.checkPartsStock();
      },
      deep: true,
    },
    energizerFreightInfo: {
      handler(newVal, oldVal) {
        // console.log('让我看看这里面是怎么展示的：newVal：', newVal, ' oldVal:', oldVal)
        if (newVal){
          setTimeout(() => {
            this.electronicFenceFreight(newVal)
          }, 500);
        }
      },
      deep: true,
    },
    interestsInfo: {
      handler(nval) {
        this.handlSelectInterestInfoData(nval);
        this.totalAllDecuMoney(nval);
      },
      deep: true,
    },
    cardPwd() {
      let pwd = this.cardPwd
        .trim()
        .replace(/[\W]/g, '')
        .replace(/\s/g, '')
        .slice(0, 16)
        .toUpperCase();
      if (pwd.length > 4) {
        const strArr = pwd.split('');
        let newStr = '';
        strArr.forEach((item, i) => {
          if ((i + 1) % 4 === 0 && i + 1 < strArr.length) {
            newStr += item + '  ';
          } else {
            newStr += item;
          }
        });
        pwd = newStr;
      }
      this.cardPwd = pwd;
    },
  },
  created() {
    this.isFirstLoad = true;
    this.initData();
    // TODO:调试代码
    this.getUserInfo();
  },
  mounted() {
    // if (this.loadding && !this.address.id) {
    //   this.editAddressDialog = !this.editAddressDialog;
    //   this.addressDialog.addressItem = this.editAddressItem;
    // }
    if (window.performance.navigation.type === 1) {
      console.log('页面被刷新');
      this.showTip = false;
    } else {
      console.log('页面被加载');
      this.showTip = true;
    }
  },
  methods: {
    ...mapActions('orderConfirm', [
      'getConfirmOrder',
      'createOrder',
      'onSetInterestsInfo',
      'getInterestsInfoFn'
    ]),
    ...mapActions('address', [
      'addNewAddress',
      'editNewAddress',
      'getAddressDetailById'
    ]),
    // 获取当前单位字符
    getCurrentUnionName(union_name, hasFuHao){
      if(this.fppConfigure && this.fppConfigure.groupItem === 'Y'){
        if(this.fppConfigure.groupItemShowRmbSymbol === 'Y'){
          return hasFuHao?'(元)': '元';
        } else {
          return '';
        }
      } else {
        return hasFuHao ?`(${union_name})`:union_name ;
      }
    },
    submitReload() {
      this.submitStockNullFlag = false;
      window.location.reload();
    },
    initData() {
      // this.buyGoodsList = []; //切换地址赋初值
      this.handleAddress();
      if (this.unionFlag) {
        checkAddress({union:this.unionFlag}).then((res) => {
          if (res && res.data && res.data.length) {
            this.checkAddressList = res.data
          }
        });
      }
    },
    // 获取商品价格处理
    getPriceDeal(num) {
      if (num) {
        return Number((num * window.union_scale) / 100).toFixed(2);
      }
      return 0;
    },
    // 获取移动端二维码
    getQrCode() {
      if (this.couponInfo && this.couponInfo.coupon == 'Y' && this.unionFlag) {
        var origin = '';
        // 环境
        if (API_ENV === 'production') {
          // 生产环境
          origin = 'corp.m.dongfangfuli.com';
        } else {
          origin = 'corp.m.' + API_ENV + '.dongfangfuli.com';
        }

        // let url = window.location.protocol + '//' + origin +'/tmall/order/confirm' + window.location.search + '&union=' + this.unionFlag;
        let url =
          window.location.protocol +
          '//' +
          origin +
          '/tmall/coupon/list?union=' +
          this.unionFlag;
        getQrcodeUrl({ url: url }).then((res) => {
          if (res) {
            this.qrcodeImg = window.URL.createObjectURL(res);
          }
        });
      }
    },
    // 根据条件判断是否要显示弹窗
    checkIsShowGoodsTip() {
      this.editdialog = !this.address.id;
      this.all_valided =
        this.notSaleGoodsList &&
        this.notSaleGoodsList.length > 0 &&
        (!this.buyGoodsList || this.buyGoodsList.length === 0);
      this.part_valided =
        this.notSaleGoodsList &&
        this.notSaleGoodsList.length > 0 &&
        this.buyGoodsList &&
        this.buyGoodsList.length > 0;
      this.invalideDialog = this.all_valided || this.part_valided;
      // console.log(editdialog)
      this.formatCreateOrderTips();
    },
    // 电子围栏运费提示
    electronicFenceFreight(info) {
      if ((info.oldTotalFreight || info.oldTotalFreight === 0) && info.oldTotalFreight != info.orderTotalFeight) {
        this.showFreightTips = true;
        setTimeout(() => {
          this.showFreightTips = false;
        }, 5000);
        document.getElementById('totalFreight').scrollIntoView({ block: "start", behavior: "smooth" });
      }
    },
    // 判断配件是否库存不足
    checkPartsStock() {
      if (this.annexItemStock == 'Y') {
        this.showPartsNoStockFlag = true;
      }
    },
    // 判断是否选择了配件
    checkChooseFlag() {
      let flag = false;
      this.buyGoodsList &&
        this.buyGoodsList.length > 0 &&
        this.buyGoodsList.forEach((ele) => {
          ele.warehouseList &&
            ele.warehouseList.length > 0 &&
            ele.warehouseList.forEach((elem) => {
              if (elem.annexTotalNum > 0) {
                flag = true;
                return flag;
              }
            });
        });
      return flag;
    },
    // 展示配件售后提示
    showPartAftersaleTip() {
      if (this.checkChooseFlag()) {
        this.showPartsTipFlag = true;
      } else {
        this.createOrderAction();
      }
    },
    /**
     * 点击福利卡判断是否需要黄牛弹窗
     */
    updateShow() {
      // 黄牛提示
      if (
        this.interestsInfo &&
        this.interestsInfo.cardInfo &&
        this.interestsInfo.cardInfo.ticketScalper === 'Y' &&
        this.isFirst
      ) {
        this.huangniuVisible = true;
        this.isFirst = false;
      }
    },

    /*
     * 获取余额、积分点击之后的金额
     */
    getChooseData(selectData) {
      // 操作过福利卡就把弹框消失
      this.showTip = false;
      this.allSelectCard = selectData;
      const params = {
        ...selectData,
        timestamp: this.confirmOrderTimestamp,
      };
      // 计算之前记录福利卡点卡、账户余额、账户积分抵扣金额
      const beforeComputedMoney = this.getComputedAmountArray(this.allCardInfo);
      this.cardUseDisabled = true;
      Loading.show();
      choosePaymentWay(params).then((res) => {
        Loading.hide();
        this.cardUseDisabled = false;
        if (res.data) {
          const afterComputedMoney = this.getComputedAmountArray(res.data);
          if (
            selectData.chooseType === 2 &&
            JSON.stringify(beforeComputedMoney) !==
              JSON.stringify(afterComputedMoney)
          ) {
            Toast.info(payTotastNames.amountRecalculate, 1.5);
          }
          this.onSetInterestsInfo(res.data);
        }
      });
    },

    // 获取前后账户、余额、点卡的抵扣金额
    getComputedAmountArray(info) {
      // 账户余额
      let balanceDeductionMoney = 0;
      // 账户积分
      let integralInfoDeductionMoney = 0;
      // 点卡金额
      let totalPointMoney = 0;
      if (info && info.balanceInfo && info.balanceInfo.deductionMoney) {
        balanceDeductionMoney = info.balanceInfo.deductionMoney;
      }
      if (info && info.integralInfo && info.integralInfo.deductionMoney) {
        integralInfoDeductionMoney = info.integralInfo.deductionMoney;
      }

      if (
        info &&
        info.cardInfo &&
        info.cardInfo.usableCardInfo &&
        info.cardInfo.usableCardInfo &&
        this.allCardInfo.cardInfo.usableCardInfo.totalPointMoney
      ) {
        totalPointMoney = info.cardInfo.usableCardInfo.totalPointMoney;
      }
      return [
        balanceDeductionMoney,
        integralInfoDeductionMoney,
        totalPointMoney
      ];
    },

    /*
     * 选中的数据处理
     */
    handlSelectInterestInfoData(data) {
      this.allCardInfo = JSON.parse(JSON.stringify(data));
      if (data && data.remainingPayAmount === 0) {
        this.enableSelect = false;
      } else {
        this.enableSelect = true;
      }
      // 账户余额
      this.allSelectCard = {
        balanceCards: [],
        enterprisePoints: [],
        goodsCards: [],
        pointCards: [],
        timestamp: '',
        chooseType: 0,
      };
      if (
        data.balanceInfo &&
        data.balanceInfo.usableBalanceInfo &&
        data.balanceInfo.usableBalanceInfo.length
      ) {
        for (let i = 0; i < data.balanceInfo.usableBalanceInfo.length; i++) {
          let item = data.balanceInfo.usableBalanceInfo[i];
          if (item.checked === 'Y') {
            let obj = {};
            obj.cardNo = item.cardKindId;
            obj.value = item.checkedValue;
            this.allSelectCard.balanceCards.push(obj);
          }
        }
      }

      // 账户积分
      if (
        data.integralInfo &&
        data.integralInfo.usableIntegralInfoList &&
        data.integralInfo.usableIntegralInfoList.length
      ) {
        for (
          let i = 0;
          i < data.integralInfo.usableIntegralInfoList.length;
          i++
        ) {
          let item = data.integralInfo.usableIntegralInfoList[i];
          if (item.checked === 'Y') {
            let obj = {};
            obj.cardNo = item.pointId;
            obj.value = item.checkedValue;
            this.allSelectCard.enterprisePoints.push(obj);
          }
        }
      }
      // 点卡
      if (
        data.cardInfo &&
        data.cardInfo.usableCardInfo &&
        data.cardInfo.usableCardInfo.pointCardList &&
        data.cardInfo.usableCardInfo.pointCardList.length
      ) {
        for (
          let i = 0;
          i < data.cardInfo.usableCardInfo.pointCardList.length;
          i++
        ) {
          let item = data.cardInfo.usableCardInfo.pointCardList[i];
          if (item.checked === 'Y') {
            let obj = {};
            obj.cardNo = item.cardNo;
            obj.value = item.checkedValue;
            this.allSelectCard.pointCards.push(obj);
          }
        }
      }

      // 次卡
      if (
        data.cardInfo &&
        data.cardInfo.usableCardInfo &&
        data.cardInfo.usableCardInfo.goodsCardList &&
        data.cardInfo.usableCardInfo.goodsCardList.length
      ) {
        for (
          let i = 0;
          i < data.cardInfo.usableCardInfo.goodsCardList.length;
          i++
        ) {
          let per = data.cardInfo.usableCardInfo.goodsCardList[i];
          var obj = {};
          obj.categoryId = per.categoryId;
          obj.goodsId = per.goodsId;
          obj.num = per.num;
          obj.cardInfos = [];
          if (per.timeCards && per.timeCards.length) {
            for (let j = 0; j < per.timeCards.length; j++) {
              if (per.timeCards[j].checked === 'Y') {
                var timeTerm = {};
                timeTerm.cardNo = per.timeCards[j].cardNo;
                timeTerm.value = per.timeCards[j].checkedValue;
                obj.cardInfos.push(timeTerm);
              }
            }
          }
          // 只有勾选了次卡才加入商品
          if (obj.cardInfos.length) {
            this.allSelectCard.goodsCards.push(obj);
          }
        }
      }
    },

    // 所有选择卡后抵扣金额
    totalAllDecuMoney(info) {
      const { balanceInfo = {}, cardInfo = {}, integralInfo = {} } = info || {};
      let totalMoney = 0;
      if (balanceInfo && balanceInfo.deductionMoney) {
        totalMoney += balanceInfo.deductionMoney;
      }
      if (integralInfo && integralInfo.deductionMoney) {
        totalMoney += integralInfo.deductionMoney;
      }

      if (
        cardInfo &&
        cardInfo.usableCardInfo &&
        (cardInfo.usableCardInfo.totalPointMoney ||
          cardInfo.usableCardInfo.totalTimeCardMoney)
      ) {
        totalMoney += cardInfo.usableCardInfo.totalPointMoney || 0;
        totalMoney += cardInfo.usableCardInfo.totalTimeCardMoney || 0;
      }
      this.totalReduce = totalMoney;
      // 需要验密
      if (info && info.password === 'N' && info.userPassword === 'N') {
        // 抵扣金额小于最大限额
        if (info && totalMoney < this.noPasswordMoney) {
          if (this.tipsPassword == 'N' || !this.tipsPassword) {
            this.tipsPassword = 'Y';
            this.noSecretSet = false;
          }
        } else {
          if (this.tipsPassword == 'Y') {
            this.tipsPassword = 'N';
            this.noSecretSet = false;
          }
        }
      }
    },

    getAddressList(defaultId) {
      getUserAddressList().then((res) => {
        if (res && res.data && res.data.length) {
          res.data.map((item, index) => {
            if (item.addressId === defaultId) {
              res.data.unshift(res.data.splice(index, 1)[0]);
            }
          });
          this.$set(this, 'addressList', res.data);
        }
        this.checkDefaultAddress(res.data);
        this.confirmOrder();
      });
    },
    // 验证是否要弹出地址添加窗口
    checkDefaultAddress(res) {
      this.isShowCancel = true;
      this.isCallBackReload = false;
      // this.address.id 判断是否是长地址
      if (!this.address.id && !this.address.addressId) {
        // 用户地址库没有数据弹出地址添加窗口
        if (res.length <= 0) {
          this.isShowCancel = false;
          this.editAddressDialog = !this.editAddressDialog;
          this.addressDialog.addressItem = this.editAddressItem;
          return;
        }
        // 不是长地址匹配用户地址库中是否有匹配项
        let list = res.filter(
          (t) =>
            t.provinceName === this.address.provinceName &&
            t.cityName === this.address.cityName &&
            t.regionName === this.address.regionName &&
            t.streetName === this.address.streetName,
        );
        if (list.length <= 0) {
          list = res.filter(
            (t) =>
              t.provinceName === this.address.provinceName &&
              t.cityName === this.address.cityName &&
              t.regionName === this.address.regionName,
          );
        }
        if (list.length <= 0) {
          list = res.filter(
            (t) =>
              t.provinceName === this.address.provinceName &&
              t.cityName === this.address.cityName,
          );
        }
        if (list.length <= 0) {
          list = res.filter(
            (t) => t.provinceName === this.address.provinceName,
          );
        }
        let userAddress = null;
        if (list.length > 0) {
          // 如果有多条匹配地址,如果只有一条直接取值
          if (list.length > 1) {
            // 获取所有默认地址,如果没有默认地址取第一条
            let das = list.filter((t) => t.defaultAddress === 1);
            if (das.length > 0) {
              userAddress = das[0];
            } else {
              userAddress = list[0];
            }
          } else {
            userAddress = list[0];
          }
        } else {
          // 短地址匹配不到长地址给默认地址,弹出添加窗口
          if (this.isFirstLoad) {
            this.isShowCancel = true;
            this.isFirstLoad = false;
            this.isCallBackReload = true;
            userAddress = null;
          } else {
            // 没有默认地址取top1
            const das = res.filter((t) => t.defaultAddress === 1);
            if (das.length > 0) {
              userAddress = das[0];
            } else {
              userAddress = res[0];
            }
          }
        }
        if (userAddress) {
          this.addressId = userAddress.addressId || userAddress.id;
          const host = '.' + window.location.hostname;
          Cookies.remove('address');
          Cookies.remove('address', { domain: '.dongfangfuli.com' });
          Cookies.remove('address', { domain: host });
          Cookies.set('address', userAddress, { expires: 365 });
          this.initData();
        } else {
          this.editAddressDialog = !this.editAddressDialog;
          this.addressDialog.addressItem = this.editAddressItem;
        }
      }
    },
    onEdit(address) {
      this.editAddressDialog = true;
      this.addressDialog = {
        dialogState: false,
        title: this.TLang('编辑收货地址', 'orderConfirm'),
        enTitle: this.TLang('编辑收货地址', 'orderConfirm'),
        addressItem: address,
      };
    },
    onAdd() {
      if (this.addressList.length >= 25) return;
      this.addressDialog = {
        dialogState: true, // 编辑 false 添加 true
        title: this.TLang('新增收货地址', 'orderConfirm'),
        enTitle: this.TLang('新增收货地址', 'orderConfirm'),
        addressItem: null,
      };
      this.editAddressDialog = true;
    },
    onSetDefaultAddress(address) {
      fetchUserAddressUpdate({
        ...address,
        id: address.addressId,
        defaultAddress: 1,
        channel: unionFlag() ? 2 : 1,
      }).then((res) => {
        this.getAddressList(this.addressId);
      });
    },
    handleAddress() {
      let addressFromCookie = Cookies.get('address');
      if (!addressFromCookie)
        throw Error(this.TLang('errorAddressTips2', 'orderConfirm'));
      if (addressFromCookie === 'undefined' || addressFromCookie === 'null') {
        throw Error(this.TLang('errorAddressTips', 'orderConfirm'));
        Cookies.remove('address');
        this.$router.push('/');
      }
      this.address = JSON.parse(addressFromCookie);
      this.handleAddressLogic();
    },
    handleBuyGoodsList() {
      const buyGoodsList = getQueryString('buyGoodsList');
      if (!buyGoodsList)
        throw Error(this.TLang('errorAddressTips3', 'orderConfirm'));
      this.goodsList = JSON.parse(buyGoodsList) || [];
    },
    // 编辑/新增 地址
    onConfirmEditAddressDialog(item) {
      if (this.addressList.length >= 25 && this.addressDialog.dialogState) {
        Toast.info(this.TLang('最多只能创建25条收货地址', 'orderConfirm'));
        return;
      }
      this.addressDialog.dialogState
        ? this.addNewAddress({ id: item.addressId, ...item })
        : this.editNewAddress({ id: item.addressId, ...item });
    },
    onCancelEditAddressDialog() {
      if (this.isCallBackReload) {
        this.getAddressList(this.addressId);
      }
      this.addressDialog.dialogState = true;
      this.addressDialog.title = this.TLang('新增收货地址', 'orderConfirm');
      this.addressDialog.addressItem = {};
      this.editAddressDialog = false;
    },
    /**
     * 短地址渲染
     */
    handleAddressLogic() {
      const { id, addressId } = this.address;
      if (!id && !addressId) {
        this.editAddressItem = this.address;
      } else {
        this.addressId = addressId || id;
      }
      this.handleBuyGoodsList();
      this.getAddressList(this.addressId);
    },
    electronicFenceFreightShow() {
      this.showFreightTips = true;
      setTimeout(() => {
        this.showFreightTips = false;
      }, 5000);
    },
    confirmOrder(hideLoading) {
      const { goodsList, addressId, address } = this;
      let confirmOrderParameters = {}; // 确认订单参数
      if (!address || !goodsList.length) return;
      if (!addressId) {
        confirmOrderParameters = {
          buyGoodsList: goodsList,
          annexBuyGoodsList: this.annexBuyGoodsList,
          ...address,
          bookingId:getQueryString('bookingId')|| null
        };
      } else {
        confirmOrderParameters = {
          buyGoodsList: goodsList,
          annexBuyGoodsList: this.annexBuyGoodsList,
          addressId,
          platform: 0,
          bookingId:getQueryString('bookingId')|| null
        };
      }

      if (!hideLoading) {
        (this.loadding = true), Loading.show();
      } else {
        // this.choosePartsLoading = true;
        Loading.show(undefined, 0)
      }
      if (window.sessionStorage.getItem('oldTotalFreight')) {
        confirmOrderParameters.oldTotalFreight = JSON.parse(JSON.stringify(window.sessionStorage.getItem('oldTotalFreight')))
        window.sessionStorage.removeItem('oldTotalFreight');
      }
      this.getConfirmOrder(confirmOrderParameters).then(() => {  Loading.hide(); }).catch(() => {
        Loading.hide();
      });
      //.final()
    },

    formatCreateOrderTips() {
      const orderType = getQueryString('orderType');
      const buyGoodsList = getQueryString('buyGoodsList') || [];
      const { goodsId, categoryId } = JSON.parse(buyGoodsList)[0] || {};
      if (this.all_valided) {
        if (Number(orderType) === 2) {
          this.confirmOrderTips = this.TLang(
            'orderGoodsInvalid',
            'orderConfirm',
          );
          this.backLink = `/shop/product/detail?cid=${categoryId}&gid=${goodsId}`;
          this.all_valideButton = this.TLang('返回详情页', 'orderConfirm');
        } else if (Number(orderType) === 1) {
          this.confirmOrderTips = this.TLang(
            'orderGoodsInvalid',
            'orderConfirm',
          );
          this.backLink = '/shop/shopping/cart';
          this.all_valideButton = this.TLang('返回购物车', 'orderConfirm');
        }
      }
      if (this.part_valided) {
        this.confirmOrderTips = this.TLang('goodsInvError', 'orderConfirm');
      }
    },
    createOrderAction() {
      this.unChooseRightsModalVisible = false;
      this.createOrderDisabled = true;
      if (this.hasHaitao) {
        this.$refs.haitaoInfo.$refs['haitaoForm'].validate((valid) => {
          v = valid;
        });
      }
      if (this.addressList.length === 0) {
        this.newAddressNotice = !this.newAddressNotice;
      }
      if (document.getElementById('userRemark') && !this.birthdayRemarkModal) {
        this.loadding = false;
        Loading.hide();
        this.createOrderDisabled = false;
        this.birthdayRemarkModal = true;
        this.userRemark =
          document.getElementById('userRemark').value ||
          this.TLang('生日快乐', 'list');
        // console.log(document.getElementById("userRemark").value);
        return;
      }

      // 提交订单 异常判断
      /**
       *  GOODS_SOLDOUT(7,"商品已下架"),
       *   GOODS_STOCK_OOS(8,"商品库存不足"),
       */

      let obj = JSON.parse(JSON.stringify(this.createOrderParameter));
      obj.terminalType = 'PC';
      if (this.noSecretSet) {
        obj.openSecretFree = 'Y';
      }
      // console.log('obj', obj)
      // return
      newCreateOrder(obj).then((res) => {
        this.createOrderDisabled = false;
        if (res && res.code && res.code === 7) {
          this.confirmOrderTips = this.TLang('goodsXiaJia', 'orderConfirm');
          this.invalideDialog = true;
          this.isReload = true;
          return;
        }
        if (res && res.code && res.code === 8) {
          this.confirmOrderTips = this.TLang('addressError', 'orderConfirm');
          this.invalideDialog = true;
          this.isReload = true;
          return;
        }
        if (res && res.code && res.code === 101030) {
          //
          this.deductionFaliedModalVisible = true;
          return;
        }
        if (res && res.code && res.code === 101033) {
          //
          this.jifendeductionFaliedModalVisible = true;
          return;
        }

        // 库存不足
        if (res && res.code && res.code === 101014) {
          //
          this.submitStockNullFlag = true;
          return;
        }

        if (res && res.code && res.msg) {
          Toast.info(res.msg);
          return;
        }
        if (res && res.body) {
          window.sessionStorage.removeItem('birthdayInfoList');
          if (res.body.payStatus === 1) {
            // 待支付
            window.location.href = res.body.payUrl;
          } else if (res.body.payStatus === 3) {
            // 支付成功

            this.$router.push(
              `payStatus?status=success&amount=${this.paymentAmount}`,
            );
          } else if (res.body.payStatus === 5) {
            // 取消订单页
            this.$router.push('payStatus?status=fail');
          }
          return;
        }
        // 指定日期配送，超过截单时间会提示错误信息，让用户刷新页面，但是res捕捉不到该信息，统一被公共方法弹出了
        // 因此，利用页面弹出的错误信息，来决定错误提示后是否刷新
        if (!res) {
          let info = document.getElementsByClassName(
            'toast-container_simple',
          )[0].innerText;
          if (info && info.indexOf('发货日期') > -1) {
            setTimeout(() => {
              this.initData();
            }, 1000);
          }
        }
      });
    },
    // 重新计算要重刷页面
    reloadPage() {
      this.sendGio('抵扣失败弹框, 重新选择', {
        content: '本次抵扣失败',
      });
      this.deductionFaliedModalVisible = false;
      this.jifendeductionFaliedModalVisible = false;
      window.location.reload();
    },
    closeDialog() {
      this.invalideDialog = false;
      if (this.isReload) {
        window.location.reload();
      }
    },
    mpClose() {
      this.visitRefundFlag = false;
    },
    mpOk() {
      this.visitRefundFlag = false;
      this.createOrderAction();
      // this.showPartAftersaleTip();
    },
    onCreateOrder() {
      debugger
      const { addressId } = this.createOrderParameter;
      let isCreateOrder = true;
      let errorMsg = '';
      if(this.settleAccountInfo.isAllowed===0){
        return
      }
      if (this.all_valided) return;
      if (!addressId) {
        this.$message.error(this.TLang('请选择用户的配送地址', 'orderConfirm'));
        return;
      }
      if (
        this.epidemicDeliverInfo.allowDelivery === 0 &&
        this.epidemicDeliverInfo.mandatoryType === 0
      )
        return;
      if (this.createOrderParameter && this.createOrderParameter.buyInfoList) {
        for (let i=0;i<this.createOrderParameter.buyInfoList.length;i++){
          const item = this.createOrderParameter.buyInfoList[i];
          if (item.deliveryWay === '3' && !item.expectDeliveryTime) {
            errorMsg = this.TLang('请选择发货时间', 'orderConfirm');
            isCreateOrder = false;
            break;
          } else if(item.deliveryWay === '1' && (!item.expectDeliveryTime || !item.expectPreciseTime)){
            document.getElementById('deliveryWay_' + item.warehouseId).scrollIntoView({block: 'center'});
            errorMsg = this.TLang('请选择期望送达时间', 'orderConfirm');
            isCreateOrder = false;
            break;
          }
        }
      }

      if (!isCreateOrder) {
        this.$message.error(errorMsg);
        return;
      }

      // TODO: 防疫包定制礼包套餐在提交订单，新增提示
      if (this.settleAccountInfo.refundFlag) {
        this.visitRefundFlag = true;
        return;
      }
      // 有可用的福利卡、余额、积分没有用, 且不处于积分盘点中 福拼拼商品不提示
      if (
        this.isCardUserful() &&
        this.interestsInfo.isThirdAccountInventory !== 1
        && this.fppConfigure.groupItem !== 'Y'
      ) {
        this.unChooseRightsModalVisible = true;
        return;
      }
      this.goNextCreateOrder(false);
    },
    // 判断未使用积分及后续操作 jumpPassword: 是否跳过验证码
    goNextCreateOrder(jumpPassword) {
      // 如果有未使用积分提醒，去除
      if (this.unChooseRightsModalVisible) {
        this.unChooseRightsModalVisible = false;
      }
      // 【定制】浙商银行，不支持三方支付，且权益不能全额抵扣时，提示用户“请返回 e 家银充值”
      if (
        this.interestsInfo &&
        this.interestsInfo.isCustom &&
        this.interestsInfo.moneyPay === 'N' &&
        this.interestsInfo.remainingPayAmount
      ) {
        Toast.info(this.TLang('请返回e家银充值', 'list'), 1.5);
        return;
      }
      // 不支持三方积分且且待支付金额不为0 toast提示
      if (
        this.interestsInfo &&
        this.interestsInfo.moneyPay === 'N' &&
        (this.interestsInfo.remainingPayAmount ||
          this.interestsInfo.isThirdAccountInventory === 1)
      ) {
        // 在积分盘点中，先提示积分盘点中
        if (this.interestsInfo.isThirdAccountInventory === 1) {
          Toast.info('积分盘点中，请稍后再试', 1.5);
          return;
        }
        if (jumpPassword) {
          Toast.info(
            '该企业暂未开通微信/支付宝付款，请使用福利卡（点卡、次卡）、账户余额或账户积分抵扣',
            1.5,
          );
          return;
        }
        Toast.info(`${this.tipTitle[0]}不足`, 1.5);
        return;
      }
      if (
        this.interestsInfo &&
        this.interestsInfo.password == 'N' &&
        this.interestsInfo.isThirdAccountInventory !== 1 &&
        !jumpPassword
      ) {
        //是否免密 Y免密 N验密
        if (
          (this.interestsInfo.userPassword === 'Y' &&
            this.totalReduce <= this.noPasswordMoney) ||
          (this.noSecretSet && this.totalReduce <= this.noPasswordMoney)
        ) {
          this.createOrderAction();
          // this.showPartAftersaleTip();
        } else {
          if (this.isHaveSelectCard()) {
            if (this.hasPayPasswordSet) {
              // 已设置密码
              this.inputPwdModalVisible = true;
              this.inputPwdError = '';
              this.pw1 = '';
              this.pw2 = '';
              this.pw3 = '';
              this.pw4 = '';
              this.$nextTick(() => {
                this.$refs.node1.focus();
              });
            } else {
              //未设置密码
              this.noPayPwdModalVisible = true;
            }
          } else {
            this.createOrderAction();
            // this.showPartAftersaleTip();
          }
        }
      } else {
        this.createOrderAction();
        // this.showPartAftersaleTip();
      }
    },
    /*
     *没有选中卡
     */
    isHaveSelectCard() {
      let isHave = false;
      // 福利卡
      let num = 0;

      if (this.allSelectCard.goodsCards.length) {
        this.allSelectCard.goodsCards.forEach((item) => {
          if (item.cardInfos && item.cardInfos.length) {
            num += item.cardInfos.length;
          }
        });
      }
      if (
        this.allSelectCard.balanceCards.length ||
        this.allSelectCard.enterprisePoints.length ||
        this.allSelectCard.pointCards.length ||
        num
      ) {
        isHave = true;
      }
      return isHave;
    },

    /*
     * 获取是否有可用的福利卡、积分、余额
     */
    isCardUserful() {
      let enableUse = false;
      // 账户余额可用总金额
      let balanceAmount = 0;
      if (
        this.interestsInfo &&
        this.interestsInfo.balanceInfo &&
        this.interestsInfo.balanceInfo.usableMoney
      ) {
        balanceAmount = this.interestsInfo.balanceInfo.usableMoney;
      }
      // 账户积分可用总金额
      let inter = 0;
      if (
        this.interestsInfo &&
        this.interestsInfo.integralInfo &&
        this.interestsInfo.integralInfo.usableMoney
      ) {
        inter = this.interestsInfo.integralInfo.usableMoney;
      }

      // 福利卡可用总张数
      let card = 0;
      if (
        this.interestsInfo &&
        this.interestsInfo.cardInfo &&
        this.interestsInfo.cardInfo.usableNum
      ) {
        card = this.interestsInfo.cardInfo.usableNum;
      }
      // 有可用金额并且选择卡数为0
      if (balanceAmount || inter || card) {
        // 福利卡
        let num = 0;

        if (this.allSelectCard.goodsCards.length) {
          this.allSelectCard.goodsCards.forEach((item) => {
            if (item.cardInfos && item.cardInfos.length) {
              num += item.cardInfos.length;
            }
          });
        }
        if (
          !this.allSelectCard.balanceCards.length &&
          !this.allSelectCard.enterprisePoints.length &&
          !this.allSelectCard.pointCards.length &&
          !num
        ) {
          enableUse = true;
        }
      }
      return enableUse;
    },
    /**
     * 用户信息查询
     */
    getUserInfo() {
      let params = {
        appId: appid,
        msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
        timestamp: +new Date(),
        version: '1.0.1',
        body: JSON.stringify({
          smsType: 2,
          sourceSys: this.unionFlag ? 4 : 1, // 官网1，百福得4
          sourceWay: 2,
          // TODO: 是否全量查询
          fullSearch: true,
          unionCode: this.unionFlag,
        }),
        sign: '',
      };
      params.sign = sha(secretKey + params.body + secretKey);
      getUserInfoHandle(params).then((res) => {
        if (res && res.data) {
          this.mobile = res.data.mobile;
          this.hasPayPasswordSet = res.data.hasPayPasswordSet;
          this.noPasswordMoney = res.data.noPasswordMoney;
          if (res.data.mobile) {
            this.modalTitle = this.TLang('输入短信验证码', 'address');
          }
        }
      });
    },
    /*
     *绑定福利卡
     */
    binkNewCard() {
      this.bindCardModalVisible = true;
      this.$nextTick(() => {
        this.$refs.myInput.focus();
      });
      this.cardPwd = '';
    },
    /**
     * 立即设置支付密码
     */
    openSetPwdModal() {
      this.sendGio('未设置支付密码弹框', '立即设置');
      this.isSetPassword = true;
      this.noPayPwdModalVisible = false;
      this.bindTelModalVisible = true;
      this.$nextTick(() => {
        this.$refs.smsCode.focus();
      });
      if (!this.time || this.time === 60) {
        this.getSms();
      }
      this.smsCode = '';
    },
    /**
     * 获取短信验证码
     */
    getSms() {
      let busType = null;
      var phoneNum = null;
      if (!this.mobile) {
        if (!this.phone) {
          Toast.info(this.TLang('请输入手机号码', 'address'));
          return;
        }
        busType = 1;
        phoneNum = this.phone;
      } else {
        phoneNum = this.mobile;
      }
      let params = {
        appId: appid,
        msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
        timestamp: +new Date(),
        version: '1.0.1',
        body: JSON.stringify({
          mobile: phoneNum,
          smsType: 2,
          sourceSys: this.unionFlag ? 4 : 1, // 官网1，百福得4
          sourceWay: 2,
          businessType: busType,
          unionCode: this.unionFlag,
        }),
        sign: '',
      };
      params.sign = sha(secretKey + params.body + secretKey);
      getSmsHandle(params).then((res) => {
        if (res && res.code == 200) {
          if (this.isSetPassword) {
            this.getCodeNum > 0 && this.sendGio('支付密码', '重新发送');
          } else {
            this.sendGio(
              '绑定手机号码',
              this.getCodeNum > 0 ? '重新获取验证码' : '获取验证码',
            );
          }
          this.getCodeNum++;
          this.countDown();
          Toast.info(this.TLang('checkCode', 'address'));
        }
      });
    },
    /**
     * 校验短信验证码
     */
    valiSms() {
      if (!this.smsCode) {
        this.$message.error(this.TLang('请输入验证码', 'address'));
        return;
      }
      if (!this.mobile) {
        // 未绑定手机号
        let params = {
          appId: appid,
          msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
          timestamp: +new Date(),
          version: '1.0.1',
          body: JSON.stringify({
            mobile: this.phone,
            smsType: 2,
            sourceSys: this.unionFlag ? 4 : 1, // 官网1，百福得4
            sourceWay: 2,
            code: this.smsCode,
            updateTime: +new Date(),
            unionCode: this.unionFlag,
          }),
          sign: '',
        };
        params.sign = sha(secretKey + params.body + secretKey);
        updateMobileHandle(params).then((res) => {
          if (res && res.code === 200) {
            this.sendGio('绑定手机号码', '下一步');
            this.bindTelModalVisible = false;
            this.setPwdModalVisible = true;
            this.paymentPwd = '';
            this.reInputPaymentPwd = '';
          }
        });
      } else {
        let params = {
          appId: appid,
          msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
          timestamp: +new Date(),
          version: '1.0.1',
          body: JSON.stringify({
            mobile: this.mobile,
            smsType: 2,
            sourceSys: this.unionFlag ? 4 : 1, // 官网1，百福得4
            sourceWay: 2,
            smsCode: this.smsCode,
            unionCode: this.unionFlag,
          }),
          sign: '',
        };
        params.sign = sha(secretKey + params.body + secretKey);
        valiSmsHandle(params).then((res) => {
          if (res && res.code === 200) {
            this.sendGio('支付密码', '下一步');
            this.bindTelModalVisible = false;
            this.setPwdModalVisible = true;
            this.paymentPwd = '';
            this.reInputPaymentPwd = '';
          }
        });
      }
    },
    /**
     * ？？？？
     */
    setPwdConfirm() {
      this.setPwdModalVisible = false;
    },
    /*
     *有4位以上连续相同的数字或者4位递增或递减
     */
    isSpecial(password) {
      let str = password;
      let re = /(\d)\1{3,}/g;
      let isRight = re.test(str);

      str += '';
      let allRe = /\d/g;
      let re1 = /(\(.*\))\1{3,}/g;
      // 判断是否递增
      let increment = str.replace(allRe, function(x1, idx) {
        return `(${x1 - idx})`;
      });
      let isIncrement = re1.test(increment);
      // 判断是否递减
      let decrement = str.replace(allRe, function(x1, idx) {
        return `(${parseInt(x1) + idx})`;
      });
      let isDecrement = re1.test(decrement);
      return isIncrement || isDecrement || isRight;
    },
    /**
     * 设置输入支付密码-确定
     */
    confirmSetPwd() {
      if (!this.paymentPwd) {
        this.setPayPwdTips = this.TLang('请输入四位数字支付密码', 'card');
        return;
      }
      if (this.isSpecial(this.paymentPwd)) {
        this.setPayPwdTips = this.TLang(
          '输入的密码4位数字不能相同或连续',
          'card',
        );
        return;
      }

      if (!this.reInputPaymentPwd) {
        this.setPayPwdTips = this.TLang('请再次输入四位数字支付密码', 'card');
        return;
      }
      if (this.paymentPwd != this.reInputPaymentPwd) {
        this.setPayPwdTips = this.TLang('checkPayPwd', 'card');
        return;
      }
      if (this.paymentPwd === this.reInputPaymentPwd) {
        this.setPayPwdTips = '';
      }
      const params = {
        appId: appid,
        msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
        timestamp: +new Date(),
        version: '1.0.1',
        body: JSON.stringify({
          code: this.smsCode,
          smsType: 2,
          sourceSys: this.unionFlag ? 4 : 1, // 官网1，百福得4
          sourceSubSys: 0,
          updateTime: formatDateTime(new Date()),
          sourceWay: 2,
          payPassword: this.paymentPwd,
          tokenType: 2,
          unionCode: this.unionFlag,
        }),
        sign: '',
      };
      this.sendGio('支付密码', '确认设置');
      params.sign = sha(secretKey + params.body + secretKey);
      setPaymentPwdHandle(params).then((res) => {
        if (res && res.code === 200) {
          this.setPwdModalVisible = false;
          this.setPwdSuccessModal = true;
        }
      });
    },
    /*
     *去使用
     */
    gotoUse() {
      this.unChooseRightsModalVisible = false;
      this.showTip = false;
      const str = this.tipTitle[1].split('#');
      if (str.length > 1) {
        document.getElementById(str[1]).scrollIntoView(true);
      }
    },
    /**
     * 忘记密码
     */
    forgrtPwd() {
      this.sendGio('支付密码', '忘记密码');
      this.inputPwdModalVisible = false;
      this.bindTelModalVisible = true;
      this.$nextTick(() => {
        this.$refs.smsCode.focus();
      });
      if (!this.time || this.time === 60) {
        this.getSms();
      }
      this.smsCode = '';
    },
    /**
     * 自动获取下一个输入框焦点
     */
    focusNext(val, nextRef, perRef) {
      this.dongjieShow = false;
      this.inputPwdError = '';
      if (val) {
        if (nextRef) {
          this.$refs[nextRef].focus();
        }
      } else {
        if (perRef) {
          this.$refs[perRef].focus();
        }
      }
    },
    /**
     * 验证支付密码
     */
    validatePayPwd() {
      this.dongjieShow = false;
      this.inputPwdError = '';

      if (!this.pw1 || !this.pw2 || !this.pw3 || !this.pw4) {
        this.inputPwdError = this.TLang('请输入四位数字支付密码', 'card') + '!';
        return;
      }
      this.sendGio('支付密码', '确定');
      let pwd = this.pw1 + this.pw2 + this.pw3 + this.pw4;
      const params = {
        appId: appid,
        msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
        timestamp: +new Date(),
        version: '1.0.1',
        body: JSON.stringify({
          password: pwd,
          tokenType: 2,
          validateTime: formatDateTime(new Date()),
        }),
        sign: '',
      };
      params.sign = sha(secretKey + params.body + secretKey);
      validatePaymentPwdHandle(params).then((res) => {
        if (res && res.code == 200) {
          this.inputPwdModalVisible = false;
          // 输入密码成功后调用创建订单
          this.createOrderAction();
          // this.showPartAftersaleTip();
        } else {
          if (res && res.code == 120026) {
            // 冻结倒计时
            if (res && res.data && res.data.expireTime) {
              this.pwdCountDown(res.data.expireTime);
            }
            this.dongjieShow = true;
          } else {
            this.pw1 = '';
            this.pw2 = '';
            this.pw3 = '';
            this.pw4 = '';
            this.$refs.node1.focus();
            if (res && res.message) {
              this.inputPwdError = res.message;
            }
          }
        }
      });
    },
    /*
     *冻结倒计时
     */
    pwdCountDown(timer) {
      if (this.clearTimer) {
        clearInterval(this.clearTimer);
      }
      let count = parseInt(timer / 1000);
      this.clearTimer = setInterval(() => {
        if (!count) {
          clearInterval(this.clearTimer);
          this.dongjieShow = false;
        }
        const minute =
          count > 0
            ? parseInt(count / 60) > 9
              ? parseInt(count / 60)
              : '0' + parseInt(count / 60)
            : '00';
        const second =
          count > 0
            ? parseInt(count % 60) > 9
              ? parseInt(count % 60)
              : '0' + parseInt(count % 60)
            : '00';

        this.countDownTimer = minute + ' : ' + second;
        count--;
      }, 1000);
    },
    /*
     *设置密码成功我知道了点击
     */
    afterSetSuccess() {
      this.sendGio('支付密码', '知道了', {
        content: '密码设置成功',
      });
      this.setPwdSuccessModal = false;
      this.createOrderAction();
      // this.showPartAftersaleTip();
    },
    /**
     * 绑卡验证
     */
    bindCardValidate() {
      const cardPwd = this.cardPwd.replace(/\s/g, '');
      if (!cardPwd || cardPwd.length < 16) {
        Toast.info(this.TLang('请输入正确的卡密', 'card'));
        return;
      }
      this.sendGio('绑定福利卡', '确定');
      const params = {
        appId: appid,
        msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
        timestamp: +new Date(),
        version: '1.0.2',
        body: JSON.stringify({
          cardPassword: cardPwd,
          businessType: 3,
          tokenType: 2,
        }),
        sign: '',
      };
      params.sign = sha(secretKey + params.body + secretKey);
      bindCardValidateHandle(params).then((res) => {
        if (res && res.success && res.data) {
          this.bindCardModalVisible = false;
          this.cardPwdError = '';
          this.cardInfoModalVisible = true;
          this.cardConfirmModelInfo = res.data;
        } else {
          this.cardPwdError = getMessageToCode(res.code, res.message);
          this.cardPwd = '';
          this.$refs.myInput.focus();
          // this.cardPwdError = res && res.message ? res.message : '';
        }
      });
    },
    /**
     * 倒计时
     */
    countDown() {
      _interval = setInterval(() => {
        if (this.time > 0) {
          this.time = this.time - 1;
        } else {
          clearInterval(_interval);
          this.time = 60;
        }
      }, 1000);
    },
    /*
     *关闭
     */
    closeClick(done, type) {
      // console.log('type', type);
      // 需要判断是不是要退出设置密码
      this.quitModalVisible = true;
      // 绑定手机号
      this.currentStep = type;
      this.bindTelModalVisible = false;
      this.setPwdModalVisible = false;
      // this.phone = '';
    },
    /*
     *二次确认退出密码设置
     */
    quitPwdSet() {
      this.sendGio('支付密码', '退出', {
        content: '是否退出设置支付密码',
      });
      this.quitModalVisible = false;
      this.bindTelModalVisible = false;
      this.setPwdModalVisible = false;
      this.paymentPwd = '';
      this.reInputPaymentPwd = '';
      this.phone = '';
    },
    /*
     *继续设置
     */
    goOnSet() {
      this.sendGio('支付密码', '继续设置', {
        content: '是否退出设置支付密码',
      });
      this.quitModalVisible = false;
      if (this.currentStep === 'bindPhone') {
        // 绑定手机号
        this.isSetPassword = false;
        this.bindTelModalVisible = true;
        this.smsCode = '';
      } else if (this.currentStep === 'setPwd') {
        // 设置密码
        this.setPwdModalVisible = true;
        this.paymentPwd = '';
        this.reInputPaymentPwd = '';
      }
    },
    // 确认绑卡
    confirmBindCard() {
      this.sendGio('绑定福利卡', '确认绑定', {
        contentTitle: this.cardConfirmModelInfo.kindName,
      });
      if(this.cardConfirmModelInfo.oneCodeRedemptionStatus == 1 && !this.isKeepCard) {
        this.$message.error('请选择是否保留实体卡使用权限');
      }
      // console.log(this.cardPwd, 'this.cardPwd');
      const cardPwd = this.cardPwd.replace(/\s/g, '');
      const params = {
        appId: appid,
        msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
        timestamp: +new Date(),
        version: '1.0.2',
        body: JSON.stringify({
          cardPassword: cardPwd,
          cardNo: this.cardConfirmModelInfo.cardNo,
          businessType: 3,
          tokenType: 2,
          oneCodeRedemptionStatus: this.cardConfirmModelInfo.oneCodeRedemptionStatus == 1 ? this.isKeepCard : null
        }),
        sign: '',
      };
      params.sign = sha(secretKey + params.body + secretKey);
      bindCardHandle(params).then((res) => {
        if (res && res.code == 200) {
          this.cardInfoModalVisible = false;
          //请求卡数据
          this.getInterestsInfoFn({
            oldTimestamp: this.oldTimestamp,
            timestamp: this.confirmOrderTimestamp,
          });
        } else {
          res && res.message && this.$message.error(res.message);
        }
      });
    },
    /**
     * 格式化余额
     */
    formatBalance(balance = 0) {
      const scale = window.union_scale || 1;
      if (!balance) {
        return ['0', '00'];
      }
      const newBalance = Number((balance * scale) / 100).toFixed(2);
      return newBalance.split('.');
    },
    /*
     *日期格式化
     */
    formatTime(str) {
      if (!str) {
        return '';
      }
      const obj = str.split(' ');
      return obj[0].replace(/\-/g, '.');
    },
    sendGio(modluename, elementname, otherParam = {}) {
      const params = {
        df_channle: unionFlag() ? '百福德' : '官网',
        df_pagename: '提交订单',
        df_modulename: modluename,
        df_elementname: elementname,
        ...otherParam,
      };
      gioClickHandle('DF_elementClick', params, 'channelGio');
    },
    showFreightRule() {
      this.showFreightRuleFlag = true;
    },
    handleClose() {
      this.showFreightRuleFlag = false;
    },
    // 修改收费配件数量 1、加比较复杂！！ 2、减为0的时候其次！
    modifyPartsNum(info, num, type, warehouseItem) {
      // console.log('info, num',info, num, type, warehouseItem);
      switch (type) {
      case 'add': // 配件数量加
        // 若入参annexBuyGoodsList列表中已包含该配件，直接更改其数量
        if (this.checkPartsIn(info, warehouseItem)) {
          this.annexBuyGoodsList.forEach((a) => {
            a.warehouseDtoList &&
                a.warehouseDtoList.length > 0 &&
                a.warehouseDtoList.forEach((b) => {
                  b.annexBuyGoodsList &&
                    b.annexBuyGoodsList.length > 0 &&
                    b.annexBuyGoodsList.forEach((c) => {
                      if (
                        c.goodsId == info.goodsId &&
                        c.categoryId == info.categoryId &&
                        a.merchantNo == warehouseItem.merchantNo &&
                        b.warehouseId == warehouseItem.warehouseId
                      ) {
                        c.num = num;
                      }
                    });
                });
          });
        } else if (
          this.checkMerchantIn(warehouseItem) &&
            this.checkWarehouseIn(warehouseItem)
        ) {
          // 入参annexBuyGoodsList列表中，含有同商家同仓库配件，则在同仓库下添加该配件
          this.annexBuyGoodsList.forEach((a) => {
            if (a.merchantNo == warehouseItem.merchantNo) {
              a.warehouseDtoList &&
                  a.warehouseDtoList.length > 0 &&
                  a.warehouseDtoList.forEach((b) => {
                    if (b.warehouseId == warehouseItem.warehouseId) {
                      b.annexBuyGoodsList.push({
                        categoryId: info.categoryId,
                        goodsId: info.goodsId,
                        num: num,
                      });
                    }
                  });
            }
          });
        } else if (
          this.checkMerchantIn(warehouseItem) &&
            !this.checkWarehouseIn(warehouseItem)
        ) {
          // 入参annexBuyGoodsList列表中，含有同商家但无同仓库，则在该商家下，添加该配件所在仓库及配件本身信息
          this.annexBuyGoodsList.forEach((a) => {
            if (a.merchantNo == warehouseItem.merchantNo) {
              a.warehouseDtoList.push({
                annexBuyGoodsList: [
                  {
                    categoryId: info.categoryId,
                    goodsId: info.goodsId,
                    num: num,
                  }
                ],
                preSell: warehouseItem.preSell,
                warehouseNo: warehouseItem.warehouseNo,
                warehouseId: warehouseItem.warehouseId,
              });
            }
          });
        } else {
          this.annexBuyGoodsList.push({
            merchantNo: warehouseItem.merchantNo,
            warehouseDtoList: [
              {
                annexBuyGoodsList: [
                  {
                    categoryId: info.categoryId,
                    goodsId: info.goodsId,
                    num: num,
                  }
                ],
                preSell: warehouseItem.preSell,
                warehouseNo: warehouseItem.warehouseNo,
                warehouseId: warehouseItem.warehouseId,
              }
            ],
          });
        }
        // this.initData();
        this.confirmOrder(true);
        break;
      case 'minus':
        // 配件数量减
        if (num == 0) {
          this.annexBuyGoodsList.forEach((a, aIndex) => {
            a.warehouseDtoList &&
                a.warehouseDtoList.length > 0 &&
                a.warehouseDtoList.forEach((b, bIndex) => {
                  b.annexBuyGoodsList &&
                    b.annexBuyGoodsList.length > 0 &&
                    b.annexBuyGoodsList.forEach((c, cIndex) => {
                      if (
                        c.goodsId == info.goodsId &&
                        c.categoryId == info.categoryId &&
                        a.merchantNo == warehouseItem.merchantNo &&
                        b.warehouseId == warehouseItem.warehouseId
                      ) {
                        // 若该仓库下有多个配件数据，则直接去除该商品数据;
                        if (b.annexBuyGoodsList.length > 1) {
                          b.annexBuyGoodsList.splice(cIndex, 1);
                        } else if (a.warehouseDtoList.length > 1) {
                          // 若该商家下有多个仓库，但该仓库下只有一条数据，则删掉该仓库数据
                          a.warehouseDtoList.splice(bIndex, 1);
                        } else {
                          // 若该商家下只有一个配件，则直接删除该商家数据
                          this.annexBuyGoodsList.splice(aIndex, 1);
                        }
                        // this.initData();
                        this.confirmOrder(true);
                        return;
                      }
                    });
                });
          });
        } else {
          this.annexBuyGoodsList.forEach((a) => {
            a.warehouseDtoList &&
                a.warehouseDtoList.length > 0 &&
                a.warehouseDtoList.forEach((b) => {
                  b.annexBuyGoodsList &&
                    b.annexBuyGoodsList.length > 0 &&
                    b.annexBuyGoodsList.forEach((c) => {
                      if (
                        c.goodsId == info.goodsId &&
                        c.categoryId == info.categoryId &&
                        a.merchantNo == warehouseItem.merchantNo &&
                        b.warehouseId == warehouseItem.warehouseId
                      ) {
                        c.num = num;
                      }
                    });
                });
          });
          // this.initData();
          this.confirmOrder(true);
        }
        break;
      case 'input':
        if (num == 0) {
          this.annexBuyGoodsList.forEach((a, aIndex) => {
            a.warehouseDtoList &&
                a.warehouseDtoList.length > 0 &&
                a.warehouseDtoList.forEach((b, bIndex) => {
                  b.annexBuyGoodsList &&
                    b.annexBuyGoodsList.length > 0 &&
                    b.annexBuyGoodsList.forEach((c, cIndex) => {
                      if (
                        c.goodsId == info.goodsId &&
                        c.categoryId == info.categoryId &&
                        a.merchantNo == warehouseItem.merchantNo &&
                        b.warehouseId == warehouseItem.warehouseId
                      ) {
                        // 若该仓库下有多个配件数据，则直接去除该商品数据;
                        if (b.annexBuyGoodsList.length > 1) {
                          b.annexBuyGoodsList.splice(cIndex, 1);
                        } else if (a.warehouseDtoList.length > 1) {
                          // 若该商家下有多个仓库，但该仓库下只有一条数据，则删掉该仓库数据
                          a.warehouseDtoList.splice(bIndex, 1);
                        } else {
                          // 若该商家下只有一个配件，则直接删除该商家数据
                          this.annexBuyGoodsList.splice(aIndex, 1);
                        }
                        // this.initData();
                        this.confirmOrder(true);
                        return;
                      }
                    });
                });
          });
        } else {
          this.annexBuyGoodsList.forEach((a) => {
            a.warehouseDtoList &&
                a.warehouseDtoList.length > 0 &&
                a.warehouseDtoList.forEach((b) => {
                  b.annexBuyGoodsList &&
                    b.annexBuyGoodsList.length > 0 &&
                    b.annexBuyGoodsList.forEach((c) => {
                      if (
                        c.goodsId == info.goodsId &&
                        c.categoryId == info.categoryId &&
                        a.merchantNo == warehouseItem.merchantNo &&
                        b.warehouseId == warehouseItem.warehouseId
                      ) {
                        c.num = num;
                      }
                    });
                });
          });
          // this.initData();
          this.confirmOrder(true);
        }
        break;
      }
    },
    checkPartsIn(info, warehouseItem) {
      let flag = false;
      if (this.annexBuyGoodsList.length > 0) {
        this.annexBuyGoodsList.forEach((a) => {
          a.warehouseDtoList &&
            a.warehouseDtoList.length > 0 &&
            a.warehouseDtoList.forEach((b) => {
              b.annexBuyGoodsList &&
                b.annexBuyGoodsList.length > 0 &&
                b.annexBuyGoodsList.forEach((c) => {
                  if (
                    c.goodsId == info.goodsId &&
                    c.categoryId == info.categoryId &&
                    a.merchantNo == warehouseItem.merchantNo &&
                    b.warehouseId == warehouseItem.warehouseId
                  ) {
                    flag = true;
                    return flag;
                  }
                });
            });
        });
      }
      return flag;
    },
    // 判断是否含有同商家
    checkMerchantIn(warehouseItem) {
      let flag = false;
      if (this.annexBuyGoodsList.length > 0) {
        this.annexBuyGoodsList.forEach((a) => {
          if (a.merchantNo == warehouseItem.merchantNo) {
            flag = true;
            return flag;
          }
        });
      }
      return flag;
    },
    // 判断是否含有同仓库
    checkWarehouseIn(warehouseItem) {
      let flag = false;
      if (this.annexBuyGoodsList.length > 0) {
        this.annexBuyGoodsList.forEach((a) => {
          if (a.merchantNo == warehouseItem.merchantNo) {
            a.warehouseDtoList &&
              a.warehouseDtoList.length > 0 &&
              a.warehouseDtoList.forEach((b) => {
                if (b.warehouseId == warehouseItem.warehouseId) {
                  flag = true;
                  return flag;
                }
              });
          }
        });
      }
      return flag;
    },
  },

  filters: {
    // 脱敏,隐藏手机号的中间四位
    mobileFormat(val) {
      if (val) {
        let tel = val + '';
        tel = tel.substr(0, 3) + '****' + tel.substr(7);
        return tel;
      } else {
        return '';
      }
    },
  },
};
</script>

<style lang="less">
@import "./index.less";
</style>
<style lang="less">
.useScope {
  padding: 13px 16px !important;
  min-width: 10px !important;
  max-width: 410px !important;
  font-size: 14px;

  color: #333333;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}
.showFreightRule {
  display: inline-block;
  font-size: 12px;

  font-weight: 400;
  color: #3d96e2;
  line-height: 17px;
  padding-right: 14px;
  background: url("../../../assets/images/order/freightRuleMoren.png") right
    center no-repeat;
  background-size: 12px auto;
  cursor: pointer;
  margin-bottom: 10px;
}
.freightDialog {
  width: 420px;
}
.freightDialog .el-dialog__title {
  font-size: 18px;

  color: #333;
  line-height: 24px;
}
.freightDialog .el-dialog__body {
  border-top: none;
  padding: 7px 40px 20px;
  font-size: 14px;

  color: #666;
  line-height: 26px;
}
.partsDialog {
  width: 420px;
}
.partsDialog .el-dialog__body {
  border-top: none;
  padding: 24px 16px;
  font-size: 14px;

  color: #333;
  line-height: 20px;
  text-align: center;
}
.partsDialog .partsKnowBtn {
  display: inline-block;
  padding: 16px 51px 15px;
  margin: 0 auto;
  background: linear-gradient(315deg, #5cb4ec 0%, #3d96e2 100%);
  border-radius: 4px;
  font-size: 16px;

  color: #fff;
  line-height: 21px;
  margin-top: 40px;
}
.line-service {
  display: flex;
  color:#666;
  font-size: 14px;
  img {
    width: 16px;
    height: 16px;
  }
}
</style>


<style lang="less">
.confirm-wrap {
  .coupon-wrap {
    line-height: 32px;
    font-size: 12px;
  
    font-weight: 500;
    color: #333;
    padding-left: 22px;
    background: url("~@assets/images/icon_coupon.png") left center no-repeat;
    background-size: 17px 13px;
    .conponCode {
      color: #fc4524;
      cursor: pointer;
    }
  }
  .order-control {
    .settle-wrap {
      .card-theme;
      padding: 24px;

      .settle-wrap-item {
        text-align: right;
        span {
          display: inline-block;

          &:last-of-type {
            width: 11%;
          }
        }
      }
    }
  }
  .birthday-nuoxin-dialog {
    transform: translateY(-50%);
    .content {
      .nuoxin-footer {
        display: flex;
        justify-content: center;
        margin-top: 44px;
        .nuoxin-confirm,
        .nuoxin-close {
          width: 120px;
          height: 40px;
          border-radius: 4px;
          text-align: center;
          line-height: 40px;
          font-size: 14px;
        }
        .nuoxin-confirm {
          background: linear-gradient(
            315deg,
            rgba(92, 180, 236, 1) 0%,
            rgba(61, 150, 226, 1) 100%
          );
        
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
        }
        .nuoxin-close {
          border: 1px solid rgba(229, 229, 229, 1);
        
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          margin-left: 20px;
        }
      }
      p {
        font-size: 14px;
      
        color: rgba(153, 153, 153, 1);
        .userremark {
          color: #111;
          word-break: break-all;
        }
      }
    }
  }
  .order-invalide-dialog,
  .couponDialog {
    transform: translateY(-50%);
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      text-align: center;
      .title {
        font-size: 18px;
        color: #333;
        font-weight: 400;
      }
      .desc {
        margin-top: 14px;
      }
      .part_valided {
        font-size: 18px;
        padding: 0 50px;
      }
      .mpTip {
        font-size: 16px;
      
        font-weight: 500;
        color: #333333;
        line-height: 22px;
        margin: 0 0 10px;
      }
      .mpDesc {
        font-size: 16px;
      
        font-weight: 400;
        color: #666666;
        line-height: 22px;
        text-align: justify;
        padding: 0 24px;
      }
      .btns {
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-radius: 4px;
        font-size: 14px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        cursor: pointer;
        color: #fff;
        background: linear-gradient(315deg, #5cb4ec, #3d96e2);
        width: 88px;
        margin-top: 20px;
        display: inline-block;
      }
      .mpOk {
        width: 120px;
        height: 39px;
        margin-right: 20px;
      }
      .mpClose {
        width: 120px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #e5e5e5;
        background: none;
        color: #666666;
      }
      .back {
        margin-left: 20px;
        border: 1px solid #3d96e2;
        background: #fff;
        color: #3d96e2;
      }
      .close {
        // border: 1px solid #3d96e2;
        // background: #fff;
        // color: #3d96e2;
      }
      .el-form-item {
        margin-bottom: 20px;
      }
    }
  }
  .order-disable {
    background: #ccc;
  }
  .couponDialog {
    .el-dialog__body {
      padding: 0;
      .title {
        position: absolute;
        top: 26px;
        left: 28px;
        font-size: 20px;
      
        font-weight: bold;
        color: #333333;
      }
      .subTitle {
        position: absolute;
        top: 64px;
        left: 28px;
        text-align: left;
        font-size: 16px;
      
        color: #666666;
      }
      .steps {
        width: 100%;
        text-align: left;
        position: absolute;
        top: 193px;
        left: 0;
        font-size: 14px;
      
        font-weight: 400;
        color: #333333;
        span {
          display: inline-block;
          text-align: center;
        }
      }
      .stepOne {
        width: 163px;
        position: absolute;
        top: 236px;
        left: 36px;
        text-align: left;
        img {
          width: 100%;
          display: block;
        }
        li {
          font-size: 14px;
        
          color: #666;
          line-height: 20px;
          margin-bottom: 20px;
        }
      }
      .stepTwo {
        width: 150px;
        position: absolute;
        top: 236px;
        left: 275px;
      }
      .stepThree {
        width: 163px;
        position: absolute;
        top: 236px;
        right: 56px;
      }
    }
  }
}

.el-tooltip__popper {
  background: #fff !important;
  box-shadow: 0px 4px 11px 0px rgba(81, 86, 95, 0.3);
  .popper__arrow {
    left: 51% !important;
  }
  .feight-weight-info {
    min-width: 240px;
    padding: 20px;
    color: rgb(81, 86, 95);
  }
  .showFreightRule {
    display: inline-block;
    font-size: 12px;
  
    font-weight: 400;
    color: #3d96e2;
    line-height: 17px;
    padding-right: 14px;
    background: url("../../../assets/images/order/freightRuleMoren.png") right
      center no-repeat;
    background-size: 12px auto;
    cursor: pointer;
    padding-left: 20px;
    margin-bottom: 10px;
  }
}
.freightDialog {
  width: 420px;
}
.freightDialog .el-dialog__title {
  font-size: 18px;

  color: #333;
  line-height: 24px;
}
.freightDialog .el-dialog__body {
  border-top: none;
  padding: 7px 40px 20px;
  font-size: 14px;

  color: #666;
  line-height: 26px;
}
.partsDialog {
  width: 420px;
}
.partsDialog .el-dialog__body {
  border-top: none;
  padding: 24px 16px;
  font-size: 14px;

  color: #333;
  line-height: 20px;
  text-align: center;
}
.partsDialog .partsKnowBtn {
  display: inline-block;
  padding: 16px 51px 15px;
  margin: 0 auto;
  background: linear-gradient(315deg, #5cb4ec 0%, #3d96e2 100%);
  border-radius: 4px;
  font-size: 16px;

  color: #fff;
  line-height: 21px;
  margin-top: 40px;
}
.order-freight {
  position: relative;
  .tips {
    position: absolute;
    right: 0;
    top: -40px;
    width: auto;
    max-width: 250px;
    font-size: 12px;
    // font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 17px;
    padding: 9px 10px;
    background: rgba(0,0,0,0.7);
    z-index: 9;
    white-space: pre-wrap;
    box-shadow: 0px 2px 8px 0px rgba(53, 59, 64, 0.15);
    border-radius: 4px;
    box-sizing: content-box;
    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      bottom: -14px;
      right: 10px;
      border: 7px solid;
      border-color: rgba(0,0,0,0.7) transparent transparent;
    }
  }
}
.price-limit-part{
  font-size: 12px;
  font-weight: 400;
  color: white;
  background: #FF5757;
  border-radius: 10px;
  height: 16px;
  line-height: 16px;
  padding: 0 4px;
  margin: 24px 24px -20px;
  display: table;
}
</style>
